import type { Catalogue } from "../i18n";

export const FR: Catalogue = {
  "failed": "en échec",
  "saving": "enregistrement",
  "waiting": "en attente",
  "today": "aujourd'hui",
  "yesterday": "hier",
  "{days}d": "{days} j",
  "{weeks}w": "{weeks} sem",
  "unlabeled": "sans nom",
  "untagged": "sans tag",
  "loading more": "chargement de la suite",
  "that's all {count}": "c'est tout, {count}",
  "shuffled": "mélangé",
  "nothing to show": "rien à montrer",
  "chi is looking again": "chi regarde à nouveau",
  "chi is looking at this one next": "chi regarde celle-ci juste après",
  "could not index that ref": "impossible d'indexer cette réf",
  "details": "détails",
  "clips are not described, write your own": "les clips ne sont pas décrits, écris ta propre description",
  "chi left this one ({reason}), write your own": "chi a laissé celle-ci de côté ({reason}), écris ta propre description",
  "chi is looking at this…": "chi regarde ça…",
  "not described yet, write your own or tap spark": "pas encore décrit, écris la tienne ou touche l'étincelle",
  "saved": "enregistré",
  "could not save the description": "impossible d'enregistrer la description",
  "chi skips clips": "chi ignore les clips",
  "described": "décrite",
  "chi is looking": "chi regarde",
  "skipped": "ignorée",
  "waiting on chi": "en attente de chi",
  "tagging {done}/{total} · {left} left": "tagging {done}/{total} · {left} restantes",
  "tagged {done}/{total} · {left} left": "taguées {done}/{total} · {left} restantes",
  "all {total} tagged": "les {total} sont taguées",
  "{shown} of {total}": "{shown} sur {total}",
  "{count} adding": "{count} en ajout",
  "{count} failed": "{count} en échec",
  "{count} to describe": "{count} à décrire",
  "busy": "occupée",
  "tap + to add pictures, drop files here, or use + ref in chrome": "touche + pour ajouter des images, dépose des fichiers ici, ou utilise + ref dans chrome",
  "every ref already has your note": "chaque réf a déjà ta note",
  "nothing matches": "rien ne correspond",
  "could not load references": "impossible de charger les références",
  "video": "vidéo",
  "all described": "tout est décrit",
  "could not read that file": "impossible de lire ce fichier",
  "nothing usable there": "rien d'utilisable là-dedans",
  "adding {count}": "ajout de {count}",
  "could not import that file": "impossible d'importer ce fichier",
  "showing {tag}": "affichage de {tag}",
  "chi is tagging {count} refs": "chi tague {count} réfs",
  "every ref is tagged": "toutes les réfs sont taguées",
  "could not start tagging": "impossible de lancer le tagging",
  "delete this reference?": "supprimer cette référence ?",
  "ref saved": "réf enregistrée",
  "ref save failed": "échec de l'enregistrement de la réf",
  "tagging done": "tagging terminé",
  "tools": "outils",
  "Tools": "Outils",
  "Talk to Chi": "Parler à Chi",
  "mode tuner, drag or tap a station": "tuner de mode, glisse ou touche une station",
  "Tool": "Outil",
  "Chi · direct line": "Chi · ligne directe",
  "{name}'s {what} · read only": "{what} de {name} · lecture seule",
  "could not open a print sheet": "impossible d'ouvrir une feuille d'impression",
  "never": "jamais",
  "could not shrink that picture": "impossible de réduire cette image",
  "could not read that picture": "impossible de lire cette image",
  "chix is processing": "chix réfléchit",
  "What should I work on next?": "Sur quoi je travaille ensuite ?",
  "nothing yet": "rien pour l'instant",
  "where it came from": "d'où ça vient",
  "rent, phone…": "loyer, téléphone…",
  "what was it": "c'était quoi",
  "mine": "le mien",
  "{name}'s": "de {name}",
  "added to {name}'s budget": "ajouté au budget de {name}",
  "added to your budget": "ajouté à ton budget",
  "couldn't add that": "impossible d'ajouter ça",
  "login with discord": "connecte-toi avec discord",
  "minipi #{id}": "minipi n° {id}",
  "a minipi": "un minipi",
  "{who} says": "{who} dit",
  "{who} · art tip": "{who} · astuce d'art",
  "pings": "rappels",
  "Late shift, {name}.": "Encore debout, {name} ?",
  "Morning, {name}.": "Bonjour, {name}.",
  "Ready when you are, {name}.": "Prête quand tu veux, {name}.",
  "Evening, {name}.": "Bonsoir, {name}.",
  "sweet": "doux",
  "edge": "tranchant",
  "retro": "rétro",
  "dark fog, film grain and chi's cyan": "brume sombre, grain de film et le cyan de chi",
  "pale daytime fog, ink and deep teal": "brume pâle de jour, encre et bleu canard profond",
  "silent hill ash and an orange coal": "cendres de silent hill et une braise orange",
  "deep water, teal fog, a sonar ping": "eau profonde, brume bleu canard, un ping de sonar",
  "rose paper and a hot pink signal": "papier rose et un signal rose vif",
  "peach cream and a coral signal": "crème de pêche et un signal corail",
  "mint milk with strawberry pink": "lait menthe et rose fraise",
  "magical girl night, violet fog, bubblegum pink": "nuit de magical girl, brume violette, rose bonbon",
  "midnight sky in periwinkle and pink": "ciel de minuit pervenche et rose",
  "the otherworld: rust black and blood red": "l'autre monde : noir rouille et rouge sang",
  "night city chrome, warning yellow, red glitch": "chrome de ville nocturne, jaune alerte, glitch rouge",
  "bruise purple fog and acid lime": "brume violet ecchymose et citron vert acide",
  "pure black and white, no mercy": "noir et blanc purs, sans pitié",
  "green crt, memory card manager at 2am": "crt vert, gestionnaire de carte mémoire à 2h du matin",
  "amber crt terminal, warm glow": "terminal crt ambre, lueur chaude",
  "cream sketch paper and flipnote orange": "papier à croquis crème et orange flipnote",
  "grey console, blue memory card screen": "console grise, écran bleu de carte mémoire",
  "four shades of handheld green": "quatre nuances de vert de console portable",
  "none": "aucun",
  "scanlines": "lignes de balayage",
  "grid": "grille",
  "dots": "points",
  "notebook": "cahier",
  "checker": "damier",
  "crosshair": "réticule",
  "sparkles": "paillettes",
  "hazard": "danger",
  "starry sky": "ciel étoilé",
  "falling leaves": "feuilles qui tombent",
  "sakura petals": "pétales de sakura",
  "snow": "neige",
  "rain": "pluie",
  "fireflies": "lucioles",
  "moves gently, stays still with calm motion": "bouge doucement, reste immobile si le mouvement calme est activé",
  "pattern on": "motif activé",
  "theme on": "thème activé",
  "bottom": "bas",
  "top": "haut",
  "one clipped corner, the original look": "un coin coupé, le look d'origine",
  "square corners everywhere": "des angles droits partout",
  "gently rounded": "légèrement arrondi",
  "very round, like a handheld menu": "très rond, comme un menu de console portable",
  "the original: Rajdhani titles, pixel labels": "l'original : titres Rajdhani, étiquettes pixel",
  "your device's own system font": "la police système de ton appareil",
  "easy to read": "facile à lire",
  "Atkinson Hyperlegible, made for low vision": "Atkinson Hyperlegible, conçue pour la basse vision",
  "dyslexia friendly": "adapté à la dyslexie",
  "OpenDyslexic, weighted letter bottoms": "OpenDyslexic, bas des lettres alourdis",
  "rounded": "arrondie",
  "Fredoka, soft and friendly": "Fredoka, douce et amicale",
  "serif": "serif",
  "Lora titles and text": "titres et texte en Lora",
  "mono": "mono",
  "Space Mono everywhere": "Space Mono partout",
  "typewriter": "machine à écrire",
  "Special Elite, inky and uneven": "Special Elite, encrée et irrégulière",
  "Caveat titles, Patrick Hand text": "titres en Caveat, texte en Patrick Hand",
  "DotGothic16, a psx menu face": "DotGothic16, une police de menu psx",
  "VT323, a green screen console": "VT323, une console à écran vert",
  "arcade": "arcade",
  "Press Start 2P titles, pixel text": "titres en Press Start 2P, texte pixel",
  "sci-fi": "science-fiction",
  "Orbitron titles over the original labels": "titres en Orbitron sur les étiquettes d'origine",
  "panels you can see through, with a blur": "panneaux transparents, avec du flou",
  "half see through": "à moitié transparent",
  "whatever the theme does": "ce que fait le thème",
  "fully opaque, easiest to read over a pattern": "totalement opaque, le plus lisible sur un motif",
  "about 820 px of content": "environ 820 px de contenu",
  "about 1040 px of content": "environ 1040 px de contenu",
  "about 1360 px of content": "environ 1360 px de contenu",
  "use the whole screen": "utilise tout l'écran",
  "centred": "centré",
  "content in the middle of the screen": "contenu au milieu de l'écran",
  "content next to the menu, spare room on the right": "contenu à côté du menu, de la place libre à droite",
  "compact": "compact",
  "tighter gaps, more on screen": "espaces réduits, plus de contenu à l'écran",
  "the original spacing": "l'espacement d'origine",
  "roomy": "aéré",
  "extra air around everything": "de l'air autour de tout",
  "pages sharpen into view": "les pages deviennent nettes",
  "a plain fade": "un simple fondu",
  "pages rise into place": "les pages montent en place",
  "pages simply appear": "les pages apparaissent simplement",
  "barely there outlines": "des contours à peine visibles",
  "the original": "l'original",
  "stronger outlines": "des contours plus marqués",
  "menu on the left": "menu à gauche",
  "menu on the right": "menu à droite",
  "radio dock at the bottom of the screen": "barre radio en bas de l'écran",
  "radio dock at the top of the screen": "barre radio en haut de l'écran",
  "brighter text and stronger lines everywhere": "texte plus clair et traits plus marqués partout",
  "a thick ring on whatever the keyboard has selected": "un anneau épais sur ce que le clavier a sélectionné",
  "loose": "large",
  "more space between letters, words and lines": "plus d'espace entre les lettres, les mots et les lignes",
  "moving speckle over everything": "grains en mouvement sur tout",
  "the slow drifting haze behind the pages": "la brume qui dérive lentement derrière les pages",
  "pattern strength": "intensité du motif",
  "how strong the background pattern is, needs a pattern": "l'intensité du motif de fond, il faut un motif",
  "dark edges of the screen": "bords sombres de l'écran",
  "makes everything bigger or smaller at once": "agrandit ou réduit tout d'un coup",
  "easy reading": "lecture facile",
  "big, clear text and strong contrast": "texte grand et net, fort contraste",
  "cream paper, OpenDyslexic, calm": "papier crème, OpenDyslexic, calme",
  "feel and access": "ressenti et accessibilité",
  "contrast": "contraste",
  "spacing": "espacement",
  "button": "bouton",
  "put back": "remis",
  "one tap sets the theme, pattern and the look below. yours only, it saves as you": "un appui règle le thème, le motif et le look ci-dessous. rien que pour toi, enregistré à ton nom",
  "reset everything": "tout réinitialiser",
  "put the whole look back to chi signal?": "remettre tout le look sur chi signal ?",
  "back to chi signal": "retour à chi signal",
  "nothing saved yet. set things up the way you like, name it and save it here": "rien d'enregistré pour l'instant. règle tout comme tu aimes, donne-lui un nom et enregistre-le ici",
  "look deleted": "look supprimé",
  "your colours": "tes couleurs",
  "the colour of highlights, selected buttons and the glow. it sits on top of any theme": "la couleur des accents, des boutons sélectionnés et de la lueur. elle se pose sur n'importe quel thème",
  "background colour": "couleur de fond",
  "your own screen colour instead of the theme's. text and contrast follow on their own": "ta propre couleur d'écran à la place de celle du thème. le texte et le contraste suivent tout seuls",
  "switch themes by itself when this device goes light or dark": "change de thème tout seul quand cet appareil passe en clair ou en sombre",
  "off keeps the theme you pick above all day": "désactivé, le thème choisi plus haut reste toute la journée",
  "in light mode": "en mode clair",
  "in dark mode": "en mode sombre",
  "how panels, buttons and cards are shaped": "la forme des panneaux, boutons et cartes",
  "the typeface for titles, labels and text. every one is bundled, nothing is downloaded from outside": "la police des titres, étiquettes et textes. toutes sont incluses, rien n'est téléchargé de l'extérieur",
  "panel glass": "verre des panneaux",
  "how see-through panels are over the background": "la transparence des panneaux sur le fond",
  "outlines": "contours",
  "how strong the thin lines around things are": "l'intensité des fins traits autour des éléments",
  "off writes labels in normal lower case, easier to read": "désactivé, les étiquettes sont en minuscules normales, plus faciles à lire",
  "background effects": "effets d'arrière-plan",
  "film grain and fog are switched off on this device, so those two sliders have nothing to move": "le grain et la brume sont désactivés sur cet appareil, ces deux curseurs n'ont donc rien à régler",
  "turn them on": "les activer",
  "grain and fog on": "grain et brume activés",
  "off on this device, turn it on above": "désactivé sur cet appareil, active-le plus haut",
  "pick a pattern above and this will change how strong it is": "choisis un motif plus haut et ceci réglera son intensité",
  "grain and fog on this device": "grain et brume sur cet appareil",
  "this switch is for this browser only. use it to calm a busy screen or a slow device": "ce réglage ne vaut que pour ce navigateur. utilise-le pour calmer un écran chargé ou un appareil lent",
  "how wide the page content gets. it only shows on screens wider than the setting, so on a phone nothing changes": "la largeur du contenu de la page. visible seulement sur les écrans plus larges que ce réglage, donc rien ne change sur téléphone",
  "page position": "position de la page",
  "where the content sits on wide screens": "l'emplacement du contenu sur les grands écrans",
  "how close or far apart things sit": "l'écart entre les éléments",
  "menu side, tablets and computers": "côté du menu, tablettes et ordinateurs",
  "which side the menu with the dial sits on, on screens wider than 900 px": "le côté où se trouve le menu avec le cadran, sur les écrans de plus de 900 px",
  "dock position, phones": "position de la barre, téléphones",
  "where the radio dock sits on phones and portrait tablets": "l'emplacement de la barre radio sur téléphone et tablette en portrait",
  "the motion as you switch pages": "l'animation quand tu changes de page",
  "size and comfort": "taille et confort",
  "brighter text and stronger lines": "texte plus clair et traits plus marqués",
  "keyboard focus ring": "anneau de focus clavier",
  "how clearly the selected control is marked when you use the keyboard": "la netteté du repère sur le contrôle sélectionné quand tu utilises le clavier",
  "text spacing": "espacement du texte",
  "more room between letters, words and lines, kinder on tired eyes": "plus de place entre les lettres, les mots et les lignes, plus doux pour des yeux fatigués",
  "turn off the quick flicker when a page opens": "désactive le bref scintillement à l'ouverture d'une page",
  "stops the fog, falling pieces and most movement on this device": "arrête la brume, les éléments qui tombent et la plupart des mouvements sur cet appareil",
  "this device only": "cet appareil uniquement",
  "a short beep when you press a button, like a console menu": "un petit bip quand tu appuies sur un bouton, comme un menu de console",
  "sounds off": "sons désactivés",
  "sounds on": "sons activés",
  "tap effect": "effet au toucher",
  "what appears where you touch the screen": "ce qui apparaît là où tu touches l'écran",
  "tap effect off": "effet au toucher désactivé",
  "tap effect on": "effet au toucher activé",
  "put this page back": "remettre cette page à zéro",
  "chip": "pastille",
  "preview": "aperçu",
  "the quick brown fox jumps over the lazy dog": "portez ce vieux whisky au juge blond qui fume",
  "look settings": "réglages du look",
  "a faint pattern behind the pages. the animated ones stay still with calm motion": "un motif discret derrière les pages. les motifs animés restent immobiles avec le mode calme",
  "left side": "côté gauche",
  "right side": "côté droit",
  "one tap sets the theme, pattern and everything below. yours only, it saves as you": "un tap règle le thème, le motif et tout ce qui suit. rien que pour toi, ça s'enregistre à ton nom",
  "your looks": "tes apparences",
  "delete this look?": "supprimer cette apparence ?",
  "delete this look": "supprimer cette apparence",
  "name this look": "nomme cette apparence",
  "save current look": "enregistrer l'apparence actuelle",
  "surprise me": "surprends-moi",
  "reset look": "réinitialiser l'apparence",
  "put the look back to chi signal?": "remettre l'apparence chi signal ?",
  "my look": "mon apparence",
  "look code": "code d'apparence",
  "copy my code": "copier mon code",
  "use this code": "utiliser ce code",
  "button sounds": "sons des boutons",
  "where you tap": "là où tu tapes",
  "the theme's own": "celle du thème",
  "pick any colour": "choisis n'importe quelle couleur",
  "that is the most looks you can keep, delete one first": "c'est le maximum d'apparences gardées, supprime-en une d'abord",
  "look saved": "apparence enregistrée",
  "share a look": "partager une apparence",
  "copy your code and send it to anyone. paste theirs here and press use to wear it": "copie ton code et envoie-le à qui tu veux. colle le leur ici et appuie sur utiliser pour l'enfiler",
  "code copied": "code copié",
  "code selected, copy it by hand": "code sélectionné, copie-le à la main",
  "that is not a look code": "ce n'est pas un code d'apparence",
  "look on": "apparence activée",
  "rolled a new look": "nouvelle apparence tirée au sort",
  "look reset": "apparence réinitialisée",
  "this device": "cet appareil",
  "sound and taps are kept on this browser only, grain and calm motion are above": "le son et les taps restent sur ce navigateur seulement, le grain et le mouvement calme sont plus haut",
  "colours": "couleurs",
  "an accent over any theme, and an optional background of your own. text and tone follow on their own": "un accent par-dessus n'importe quel thème, et un arrière-plan à toi si tu veux. le texte et le ton suivent tout seuls",
  "shape and type": "forme et police",
  "accent": "accent",
  "corners": "coins",
  "font": "police",
  "panels": "panneaux",
  "capital letters on labels": "majuscules sur les étiquettes",
  "atmosphere": "ambiance",
  "how much fog, grain and pattern sit behind everything. grain and fog also need the switch below": "combien de brume, de grain et de motif derrière tout. le grain et la brume ont aussi besoin de l'interrupteur plus bas",
  "layout and motion": "mise en page et mouvement",
  "page width": "largeur de page",
  "rail side, on tablets and desktops": "côté du rail, sur tablette et ordinateur",
  "when a page opens": "à l'ouverture d'une page",
  "glitch on page titles": "glitch sur les titres de page",
  "station worlds": "univers des stations",
  "each station gets its own colour, moving backdrop and a title that locks in when a page opens": "chaque station a sa couleur, un fond animé et un titre qui se verrouille à l'ouverture d'une page",
  "tilt and magnetic": "inclinaison et aimant",
  "tiles lean toward your finger or pointer and main buttons pull toward the cursor": "les cartes s'inclinent vers votre doigt ou le pointeur et les boutons principaux se rapprochent du curseur",
  "day and night": "jour et nuit",
  "switch themes with this device's light or dark setting": "changer de thème selon le mode clair ou sombre de cet appareil",
  "follow the device": "suivre l'appareil",
  "light mode": "mode clair",
  "dark mode": "mode sombre",
  "cut": "coupé",
  "sharp": "net",
  "round": "rond",
  "signal": "signal",
  "clean": "net",
  "pixel": "pixel",
  "handwritten": "manuscrit",
  "clear glass": "verre clair",
  "frosted": "dépoli",
  "theme": "thème",
  "solid": "plein",
  "narrow": "étroit",
  "normal": "normal",
  "full": "pleine",
  "blur in": "flou entrant",
  "fade": "fondu",
  "slide up": "glisser vers le haut",
  "faint": "discrètes",
  "bold": "marquées",
  "right": "droite",
  "film grain": "grain de pellicule",
  "pattern": "motif",
  "vignette": "vignettage",
  "interface size": "taille de l'interface",
  "blip": "bip",
  "click": "clic",
  "ripple": "ondulation",
  "spark": "étincelle",
  "chi signal": "chi signal",
  "the original, untouched": "l'original, intact",
  "silent hill": "silent hill",
  "ember, heavy fog and grain": "braise, brume épaisse et grain",
  "flipnote": "flipnote",
  "sketch paper, handwriting, soft corners": "papier à croquis, écriture à la main, coins doux",
  "memory card": "carte mémoire",
  "psx grey, pixel type, sharp": "gris psx, police pixel, net",
  "magical girl": "magical girl",
  "lilac night, sparkles, round": "nuit lilas, paillettes, rond",
  "dsi menu": "menu dsi",
  "glossy white, rounded, clean": "blanc brillant, arrondi, net",
  "terminal": "terminal",
  "green crt, monospace, no frills": "crt vert, chasse fixe, sans fioritures",
  "the rain": "la pluie",
  "code rain on black": "pluie de code sur noir",
  "night city": "ville de nuit",
  "warning yellow, hazard stripes": "jaune d'alerte, bandes de danger",
  "cozy afternoon": "après-midi cosy",
  "peach cream and falling petals": "crème pêche et pétales qui tombent",
  "midnight forest": "forêt de minuit",
  "moss and fireflies": "mousse et lucioles",
  "mall soft": "mall doux",
  "vapor pink and cyan edge": "rose vapor et bord cyan",
  "drafting table": "table à dessin",
  "blueprint, grid and mono": "cyanotype, grille et chasse fixe",
  "blue screen": "écran bleu",
  "a very polite crash": "un plantage très poli",
  "deep sea": "mer profonde",
  "abyss and slow bubbles": "abysse et bulles lentes",
  "quiet paper": "papier tranquille",
  "light, calm, no effects": "clair, calme, sans effets",
  "nature": "nature",
  "sunset": "coucher de soleil",
  "dusk violet and a burnt orange sun": "violet du crépuscule et soleil orange brûlé",
  "forest": "forêt",
  "moss, wet bark and leaf green": "mousse, écorce mouillée et vert feuille",
  "coffee": "café",
  "espresso brown and crema": "brun espresso et crema",
  "ice": "glace",
  "frozen pale blue and deep water ink": "bleu pâle gelé et encre d'eau profonde",
  "matcha": "matcha",
  "soft green tea and a dark leaf": "thé vert doux et feuille sombre",
  "vapor": "vapor",
  "late night mall, pink on purple with a cyan edge": "centre commercial tard le soir, rose sur violet avec un bord cyan",
  "bsod": "bsod",
  "a blue screen, white text, nothing to hide": "un écran bleu, du texte blanc, rien à cacher",
  "blueprint": "cyanotype",
  "cyan ink on drafting blue": "encre cyan sur bleu de dessin",
  "dsi": "dsi",
  "glossy white handheld and its blue menu": "console portable blanc brillant et son menu bleu",
  "waves": "vagues",
  "honeycomb": "nid d'abeille",
  "diamonds": "losanges",
  "cross stitch": "point de croix",
  "embers": "braises",
  "bubbles": "bulles",
  "code rain": "pluie de code",
  "saved, type to replace": "enregistrée, tape pour remplacer",
  "not set": "non défini",
  "token copied": "jeton copié",
  "make a new extension token? the old one stops working until you paste the new one in": "créer un nouveau jeton d'extension ? l'ancien ne marche plus tant que tu n'as pas collé le nouveau",
  "new token made": "nouveau jeton créé",
  "log out of chix on every device?": "se déconnecter de chix sur tous les appareils ?",
  "£ pound": "£ livre",
  "C$ canadian": "C$ canadien",
  "A$ australian": "A$ australien",
  "CHF swiss franc": "CHF franc suisse",
  "talking to plane": "connexion à plane",
  "connected to {workspace}, now pick your boards": "connecté à {workspace}, choisis maintenant tes tableaux",
  "open plane": "ouvrir plane",
  "in safari, create an api token in profile settings, paste it below, then save": "dans safari, crée un jeton api dans les réglages du profil, colle-le en dessous, puis enregistre",
  "couldn't do that": "impossible de faire ça",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google a refusé la clé de la carte. vérifie qu'elle est autorisée sur ce site et que maps javascript api est activée",
  "the map needs a key to draw, searches and routes still work below": "la carte a besoin d'une clé pour s'afficher, les recherches et itinéraires marchent toujours en dessous",
  "the map couldn't load. searches and routes still work below": "la carte n'a pas pu charger. les recherches et itinéraires marchent toujours en dessous",
  "you": "toi",
  "new pin": "nouvelle épingle",
  "open now": "ouvert maintenant",
  "closed now": "fermé maintenant",
  "new": "nouveau",
  "{rating} from 1 review": "{rating} · 1 avis",
  "{rating} from {count} reviews": "{rating} · {count} avis",
  "no reviews yet": "pas encore d'avis",
  "no parking info": "pas d'info sur le parking",
  "no parking listed": "aucun parking indiqué",
  "pin": "épingle",
  "{place} is stop {letter}": "{place} est l'étape {letter}",
  "save": "enregistrer",
  "looking…": "recherche…",
  "nothing found there. try further out or other words": "rien trouvé là. essaie plus loin ou d'autres mots",
  "pick something to look for, or search above": "choisis quelque chose à chercher, ou cherche au-dessus",
  "{what} within {distance} of {place}": "{what} à moins de {distance} de {place}",
  "around {place}": "autour de {place}",
  "ten stops is the most": "dix étapes maximum",
  "taken out of saved": "retiré des lieux enregistrés",
  "remove {name}?": "retirer {name} ?",
  "nothing saved yet": "rien d'enregistré pour l'instant",
  "tap the map": "touche la carte",
  "drop a pin": "poser une épingle",
  "edit {name}": "modifier {name}",
  "save pin": "enregistrer l'épingle",
  "my pin": "mon épingle",
  "pinned": "épinglé",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "les lieux, notes, parkings et itinéraires viennent de google maps. il faut une clé de ton compte google cloud, google offre un quota gratuit chaque mois",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractal n'a pas encore ajouté de clé google maps, donc la carte ne peut rien chercher",
  "within {distance}": "à moins de {distance}",
  "this area": "cette zone",
  "couldn't find where you are, staying around {place}": "impossible de te localiser, on reste autour de {place}",
  "amber": "ambre",
  "green": "vert",
  "red": "rouge",
  "tap the map where the pin goes": "touche la carte là où va l'épingle",
  "couldn't find where you are": "impossible de te localiser",
  "take this pin off the map?": "retirer cette épingle de la carte ?",
  "where i am": "où je suis",
  "home ({place})": "maison ({place})",
  "name this route": "nomme cet itinéraire",
  "{from} to {to}": "de {from} à {to}",
  "route saved": "itinéraire enregistré",
  "food": "nourriture",
  "pubs and bars": "pubs et bars",
  "takeaway": "à emporter",
  "shops": "magasins",
  "fuel": "carburant",
  "pharmacy": "pharmacie",
  "parks": "parcs",
  "things to see": "à voir",
  "cinema": "cinéma",
  "ev charging": "recharge électrique",
  "drive": "voiture",
  "walk": "à pied",
  "cycle": "vélo",
  "{amount} a month": "{amount} par mois",
  "by {date}": "d'ici le {date}",
  "monthly, stopped {date}": "mensuel, arrêté le {date}",
  "monthly from {date}": "mensuel depuis {date}",
  "on {date}": "le {date}",
  "added by you": "ajouté par toi",
  "added by {name}": "ajouté par {name}",
  "{done} paid of {total} · {left} left": "{done} payé sur {total} · reste {left}",
  "paid off · {total}": "remboursé · {total}",
  "{done} saved of {total} · {left} to go": "{done} épargné sur {total} · encore {left}",
  "reached · {done}": "atteint · {done}",
  "in": "entrée",
  "bill": "facture",
  "cost": "dépense",
  "debt": "dette",
  "goal": "objectif",
  "remove {name}? its history goes too": "retirer {name} ? son historique part aussi",
  "restart": "redémarrer",
  "stop": "arrêter",
  "paid": "payé",
  "payment logged": "paiement noté",
  "saved toward it": "mis de côté",
  "took back the last one": "dernier retiré",
  "{amount} left": "reste {amount}",
  "{amount} saved": "{amount} épargné",
  "out": "sorties",
  "no monthly bills yet": "pas encore de factures mensuelles",
  "owe": "dû",
  "{percent}% of {total}": "{percent} % de {total}",
  "{amount} this month": "{amount} ce mois-ci",
  "owed in total": "dû au total",
  "target": "cible",
  "a month (optional)": "par mois (facultatif)",
  "how much comes in": "combien rentre",
  "how much": "combien",
  "by": "d'ici le",
  "since": "depuis",
  "from": "depuis",
  "on": "le",
  "where it comes from": "d'où ça vient",
  "rent, phone, adobe…": "loyer, téléphone, adobe…",
  "what you bought": "ce que tu as acheté",
  "who or what you owe": "à qui ou quoi tu dois",
  "what you're saving for": "pour quoi tu économises",
  "add": "ajouter",
  "add to the budget": "ajouter au budget",
  "added": "ajouté",
  "couldn't save that": "impossible d'enregistrer ça",
  "due: {title}": "à rendre : {title}",
  "unexpected \"{char}\"": "« {char} » inattendu",
  "missing )": "il manque )",
  "expected a number": "un nombre était attendu",
  "that goes to infinity": "ça part à l'infini",
  "not set, add it in setup": "pas définie, ajoute-la dans réglages",
  "{spent} of {budget} for tagging": "{spent} sur {budget} pour le tagging",
  "no cap on tagging": "pas de plafond pour le tagging",
  "{count} refs waiting since {time}": "{count} réfs en attente depuis {time}",
  "none running": "rien en cours",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} appels · {input} entrée · {cached} en cache · {output} sortie",
  "nothing yet for {month}": "rien encore pour {month}",
  "{calls} calls": "{calls} appels",
  "split starts with the next answer": "le partage commence à la prochaine réponse",
  "could not read claude usage": "impossible de lire l'utilisation de claude",
  "all": "tout",
  "start {name}?": "démarrer {name} ?",
  "starting {name}...": "démarrage de {name}...",
  "{name} start sent": "démarrage de {name} envoyé",
  "stop {name}?": "arrêter {name} ?",
  "stopping {name}...": "arrêt de {name}...",
  "{name} stop sent": "arrêt de {name} envoyé",
  "restart {name}?": "redémarrer {name} ?",
  "restarting {name}...": "redémarrage de {name}...",
  "{name} restart sent": "redémarrage de {name} envoyé",
  "running": "en cours",
  "stopped": "arrêté",
  "crash looping": "plante en boucle",
  "starting": "démarrage",
  "up {time}": "en ligne depuis {time}",
  "{count} restarts": "{count} redémarrages",
  "{name} logs": "journaux de {name}",
  "loading...": "chargement...",
  "{used} of {total}": "{used} sur {total}",
  "could not reach the server: {error}": "impossible de joindre le serveur : {error}",
  "validating caddy...": "validation de caddy...",
  "caddy reloaded": "caddy rechargé",
  "{label}, one per line": "{label}, un par ligne",
  "change picture": "changer l'image",
  "all {n}": "tous · {n}",
  "unsorted": "non classés",
  "under a cent": "moins d'un centime",
  "chi looking {done}/{total}": "chi regarde {done}/{total}",
  "chi look {done}/{total}": "regard de chi {done}/{total}",
  "chi looked": "chi a regardé",
  "chi has looked at every character picture": "chi a regardé toutes les images des personnages",
  "{n} more wait for another press.": "{n} autres attendent le prochain appui.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi a regardé {done} images de personnages sur {total}. regarder les {count} suivantes pour environ {price} ? ça passe par le lot à moitié prix, donc ça peut prendre du temps.",
  "chi is looking at {count} pictures": "chi regarde {count} images",
  "could not start chi": "impossible de lancer chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "chi regarde 1 image de {name} qu'elle n'a pas vue, pour environ {price} ?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "chi regarde {count} images de {name} qu'elle n'a pas vues, pour environ {price} ?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi a vu les {total} images de {name}. les regarder à nouveau depuis le début, pour environ {price} ?",
  "chi is looking at {name}": "chi regarde {name}",
  "picture {n}": "image {n}",
  "adding 1 picture…": "ajout d'1 image…",
  "adding {n} pictures…": "ajout de {n} images…",
  "picture added": "image ajoutée",
  "{n} pictures added": "{n} images ajoutées",
  "could not add the picture": "impossible d'ajouter l'image",
  "take this picture off the character?": "retirer cette image du personnage ?",
  "picture removed": "image retirée",
  "could not remove the picture": "impossible de retirer l'image",
  "sheet picture changed": "image de fiche changée",
  "could not change the picture": "impossible de changer l'image",
  "fetching characters from {source}…": "récupération des personnages depuis {source}…",
  "{n} found": "{n} trouvés",
  "{n} added": "{n} ajoutés",
  "{n} updated": "{n} mis à jour",
  "{n} duplicates merged": "{n} doublons fusionnés",
  "{n} failed": "{n} en échec",
  "{source} import failed": "l'import depuis {source} a échoué",
  "aka {names}": "alias {names}",
  "{n} pictures": "{n} images",
  "merge into {name}": "fusionner avec {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "fusionner {other} avec {name} ? la fiche de {other} disparaît et ses images passent à {name}.",
  "{other} merged into {name}": "{other} fusionné avec {name}",
  "the sheet": "la fiche",
  "could not merge": "impossible de fusionner",
  "character saved": "personnage enregistré",
  "could not save": "impossible d'enregistrer",
  "delete {name}?": "supprimer {name} ?",
  "1 block today": "1 bloc aujourd'hui",
  "{n} blocks today": "{n} blocs aujourd'hui",
  "resume": "reprendre",
  "back to drawing": "retour au dessin",
  "break time, stretch your hand": "pause : étire ta main",
  "focus block started": "bloc de concentration lancé",
  "take a break": "fais une pause",
  "type minutes, like 40 or 1h30": "tape des minutes, comme 40 ou 1h30",
  "drop this picture": "retirer cette image",
  "toss {hex}?": "jeter {hex} ?",
  "copied {hex}": "{hex} copié",
  "prompt copied": "prompt copié",
  "commissions": "commandes",
  "no commissions": "aucune commande",
  "comms money": "argent des commandes",
  "{n} paid": "{n} payées",
  "{n} others": "{n} autres",
  "nothing paid yet": "rien de payé pour l'instant",
  "that task is done or gone": "cette tâche est finie ou supprimée",
  "unlink {title}": "délier {title}",
  "no task matches": "aucune tâche ne correspond",
  "no open tasks. add one in tasks first": "aucune tâche ouverte. ajoutes-en une dans tâches d'abord",
  "for {client}": "pour {client}",
  "paid {day}": "payé le {day}",
  "due {date}": "pour le {date}",
  "commission saved": "commande enregistrée",
  "commission added": "commande ajoutée",
  "break": "pause",
  "unknown": "inconnu",
  "fapped {n} times": "fap {n} fois",
  "no doodles match": "aucun gribouillis ne correspond",
  "could not load the doodles": "impossible de charger les gribouillis",
  "no picture on the clipboard": "pas d'image dans le presse-papiers",
  "pick a picture": "choisis une image",
  "you can look at the doodles, not add them": "tu peux voir les gribouillis, pas en ajouter",
  "adding the doodle": "ajout du gribouillis",
  "adding {n} of {total}": "ajout de {n} sur {total}",
  "{n} doodles added": "{n} gribouillis ajoutés",
  "could not add that": "impossible d'ajouter ça",
  "press ctrl+v or ⌘v to paste": "appuie sur ctrl+v ou ⌘v pour coller",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "impossible de lire le presse-papiers, essaie ctrl+v ou ⌘v",
  "gone": "disparu",
  "remove {name}": "retirer {name}",
  "new doodle": "nouveau gribouillis",
  "doodle saved": "gribouillis enregistré",
  "delete this doodle?": "supprimer ce gribouillis ?",
  "could not delete": "impossible de supprimer",
  "by {name}": "par {name}",
  "one a day per doodle, come back tomorrow": "un par jour et par gribouillis, reviens demain",
  "today ✓ {n}": "aujourd'hui ✓ {n}",
  "fapped {n}×": "fap {n}×",
  "you {n}": "toi {n}",
  "could not count that": "impossible de compter ça",
  "random full body poses from the pocketbase library": "poses en pied au hasard depuis la bibliothèque pocketbase",
  "{n} refs in the pool": "{n} réfs dans la réserve",
  "no refs match yet": "aucune réf ne correspond pour l'instant",
  "could not fetch poses": "impossible de récupérer des poses",
  "play": "lecture",
  "no poses to draw from": "aucune pose à dessiner",
  "{n} poses done, nice": "{n} poses faites, bravo",
  "{n} answered today": "{n} répondues aujourd'hui",
  "{n} day streak": "série de {n} jours",
  "nothing due right now, {n} learning cards come back in {minutes}m": "rien à revoir pour l'instant, {n} cartes en cours reviennent dans {minutes} min",
  "today's cards are done, see you tomorrow": "les cartes du jour sont faites, à demain",
  "no cards to study, switch a deck on below": "aucune carte à étudier, active un paquet en dessous",
  "{seen} of {total} seen · {solid} solid": "{seen} sur {total} vues · {solid} acquises",
  "study {deck}": "étudier {deck}",
  "could not load the deck": "impossible de charger le paquet",
  "could not save that answer": "impossible d'enregistrer cette réponse",
  "could not save the deck setup": "impossible d'enregistrer les réglages du paquet",
  "basics": "l'essentiel",
  "favourites": "préférés",
  "likes and goals": "goûts et objectifs",
  "looks": "apparence",
  "identity": "identité",
  "sexuality": "sexualité",
  "story": "histoire",
  "for chi": "pour chi",
  "trivia": "anecdotes",
  "created by": "créé par",
  "world": "monde",
  "location": "lieu",
  "occupation": "métier",
  "gender": "genre",
  "height": "taille",
  "favourite food": "plat préféré",
  "smell": "odeur",
  "pet peeve": "bête noire",
  "likes": "aime",
  "dislikes": "n'aime pas",
  "look in short": "apparence en bref",
  "body": "corps",
  "clothes": "vêtements",
  "visual features": "traits visuels",
  "speaking": "façon de parler",
  "personality": "personnalité",
  "relationships": "relations",
  "items": "objets",
  "skills": "compétences",
  "preferences": "préférences",
  "fetishes": "fétiches",
  "sexual trivia": "anecdotes sexuelles",
  "rpg sheet": "fiche jdr",
  "fractal's notes for chi": "notes de fractal pour chi",
  "sees your {kinds}": "voit tes {kinds}",
  "sees nothing of yours": "ne voit rien de toi",
  "{line}, adds to your {kinds}": "{line}, peut ajouter à tes {kinds}",
  "{name} can add to your {kind}": "{name} peut ajouter à tes {kind}",
  "{name} can only read your {kind}": "{name} peut seulement lire tes {kind}",
  "{name} can see your {kind}": "{name} peut voir tes {kind}",
  "{kind} hidden from {name}": "{kind} masqués pour {name}",
  "{name} can see everything you can share": "{name} peut voir tout ce que tu peux partager",
  "{name} sees nothing of yours now": "{name} ne voit plus rien de toi",
  "share {kind} with {name}": "partager {kind} avec {name}",
  "you don't have notes, pings or anything else to share yet": "tu n'as pas encore de notes, de rappels ou autre chose à partager",
  "share all": "tout partager",
  "share none": "ne rien partager",
  "nobody else is in chix yet": "personne d'autre n'est encore sur chix",
  "shares their {kinds}": "partage ses {kinds}",
  "Calendar events": "Événements du calendrier",
  "Places and routes": "Lieux et trajets",
  "your sticky notes": "tes post-it",
  "reminders, alarms and timers": "rappels, alarmes et minuteurs",
  "your own events on the month": "tes propres événements du mois",
  "plane and chix bot": "plane et le bot chix",
  "clients, prices, status, linked tasks and money stats": "clients, prix, statut, tâches liées et stats d'argent",
  "bills, costs, debts and goals": "factures, dépenses, dettes et objectifs",
  "what you keep up and your streaks": "ce que tu tiens et tes séries",
  "spots and routes you saved on the map": "lieux et trajets enregistrés sur la carte",
  "Can add to it": "Peut y ajouter",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "factures, dépenses, entrées d'argent et paiements, à son nom. la personne ne peut modifier que ce qu'elle a ajouté",
  "off": "désactivé",
  "{on} of {total} on · chi {spent} of {cap}": "{on} sur {total} activés · chi {spent} sur {cap}",
  "{on} of {total} on · chi {spent}": "{on} sur {total} activés · chi {spent}",
  "{feature} off for {name}": "{feature} désactivé pour {name}",
  "{name} can view {feature}": "{name} peut voir {feature}",
  "{name} can edit {feature}": "{name} peut modifier {feature}",
  "{feature} for {name}": "{feature} pour {name}",
  "monthly chi cap, usd": "plafond mensuel chi, usd",
  "{name}'s chi stops at {amount} a month": "le chi de {name} s'arrête à {amount} par mois",
  "no cap for {name}": "pas de plafond pour {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} sur {count} réponses ce mois-ci. 0 = pas de plafond",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "retirer {name} ? la personne sera déconnectée. ses notes et discussions restent sur le serveur si tu la rajoutes",
  "{name} removed": "{name} retiré",
  "just you for now": "juste toi pour l'instant",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} peut se connecter maintenant. la personne commence avec chi, notes, rappels et routines",
  "Calendar and pings": "Calendrier et rappels",
  "Chi speaker": "Enceinte Chi",
  "Discord messages": "Messages discord",
  "Keys and server setup": "Clés et réglages serveur",
  "their own chat and memory, on your claude account": "son propre chat et sa mémoire, sur ton compte claude",
  "the shared ref library": "la bibliothèque de réfs partagée",
  "the shared oc sheets": "les fiches d'oc partagées",
  "their own": "les siens",
  "plane and chix bot, their own": "plane et le bot chix, les siens",
  "timer, palette, prompts, comms and their money stats": "minuteur, palette, idées, commandes et ses stats d'argent",
  "their own bills, costs, debts and goals": "ses propres factures, dépenses, dettes et objectifs",
  "places nearby, routes and their saved spots, on your google maps key": "lieux proches, trajets et ses lieux enregistrés, avec ta clé google maps",
  "gesture drawing and japanese": "croquis de gestes et japonais",
  "the shared doodle wall": "le mur de gribouillis partagé",
  "their own scan library": "sa propre bibliothèque de scans",
  "their pings ring at home, chi answers their voice": "ses rappels sonnent à la maison, chi répond à sa voix",
  "chi can dm your contacts for them": "chi peut envoyer des mp à tes contacts pour eux",
  "vps panel and bot controls": "panneau vps et contrôles du bot",
  "every log line": "chaque ligne de journal",
  "spend and billing": "dépenses et facturation",
  "api keys, ssh": "clés api, ssh",
  "this dashboard": "ce tableau de bord",
  "tap to upload": "touche pour envoyer",
  "{count} kept": "{count} gardés",
  "uploading {n} of {total}": "envoi {n} sur {total}",
  "scan kept": "scan gardé",
  "{count} scans kept": "{count} scans gardés",
  "upload failed": "échec de l'envoi",
  "the brother is scanning": "la brother scanne",
  "scan failed": "échec du scan",
  "saving {n} of {total}": "enregistrement {n} sur {total}",
  "added to scans": "ajouté aux scans",
  "could not save that": "impossible d'enregistrer",
  "pdf scan, use download to open it": "scan pdf, utilise télécharger pour l'ouvrir",
  "delete this scan?": "supprimer ce scan ?",
  "days apart": "jours d'écart",
  "times a week, any days": "fois par semaine, n'importe quel jour",
  "day of the month": "jour du mois",
  "added by another part of chix, ticked off there too": "ajoutée depuis une autre section de chix, cochée aussi là-bas",
  "delete {title} and its history?": "supprimer {title} et son historique ?",
  "no routines": "pas de routines",
  "ChiX routine": "Routine ChiX",
  "time for {title}": "c'est l'heure de {title}",
  "weekdays": "en semaine",
  "every {n} days": "tous les {n} jours",
  "{n}x a week": "{n} fois par semaine",
  "monthly on day {day}": "chaque mois le {day}",
  "{done}/{times} this week": "{done}/{times} cette semaine",
  "ping {time}": "rappel {time}",
  "{n}w streak": "série de {n} sem",
  "{n} streak": "série de {n}",
  "{title} done": "{title} fini",
  "sticky {date}": "post-it {date}",
  "saved {time}": "enregistré {time}",
  "nothing coming up": "rien de prévu",
  "edit chix task": "modifier la tâche chix",
  "new chix task": "nouvelle tâche chix",
  "saving...": "enregistrement...",
  "mark \"{title}\" as done?": "marquer « {title} » comme faite ?",
  "high": "haute",
  "medium": "moyenne",
  "low": "basse",
  "{count} shown, updated {time}": "{count} affichées, mis à jour {time}",
  "nothing pending": "rien en attente",
  "night": "nuit",
  "fog": "brume",
  "ember": "braise",
  "abyss": "abysse",
  "petal": "pétale",
  "peach": "pêche",
  "mint": "menthe",
  "lilac": "lilas",
  "starlight": "lumière d'étoiles",
  "venom": "venin",
  "pocket": "poche",
  "{title} reached, tap done to cross it off": "{title} atteint, touche fini pour la barrer",
  "delete {title}? it won't come back": "supprimer {title} ? ça ne reviendra pas",
  "done · {n}": "faits · {n}",
  "no goals": "pas d'objectifs",
  "this one's done, saving keeps it crossed out": "celui-ci est fini, enregistrer le garde barré",
  "no goals on the go": "aucun objectif en cours",
  "add a couple of options": "ajoute quelques options",
  "last one standing: {label}": "dernière option en lice : {label}",
  "everything's been knocked out": "tout a été éliminé",
  "spinning": "ça tourne",
  "the wheel says": "la roue dit",
  "new wheel": "nouvelle roue",
  "knocked out": "éliminée",
  "{n} on the wheel, {out} knocked out": "{n} sur la roue, {out} éliminées",
  "{n} on the wheel": "{n} sur la roue",
  "just now": "à l'instant",
  "{n}m ago": "il y a {n} min",
  "{n}h ago": "il y a {n} h",
  "ready": "prêt",
  "flick the wheel or press spin": "lance la roue d'un geste ou appuie sur lancer",
  "add a couple of options to spin": "ajoute quelques options pour lancer la roue",
  "a wheel holds {max} options": "une roue contient {max} options",
  "only {room} fit, a wheel holds {max}": "seulement {room} rentrent, une roue en contient {max}",
  "my characters": "mes personnages",
  "there aren't enough characters yet": "pas encore assez de personnages",
  "which oc": "quel oc",
  "{name} copy": "copie de {name}",
  "delete the wheel \"{name}\"?": "supprimer la roue « {name} » ?",
  "yes or no": "oui ou non",
  "what to draw": "quoi dessiner",
  "dinner": "dîner",
  "dice": "dé",
  "who does it": "qui s'en charge",
  "yes": "oui",
  "no": "non",
  "gesture warm up": "échauffement gestuel",
  "an oc": "un oc",
  "hands and feet": "mains et pieds",
  "background": "arrière-plan",
  "comic page": "page de bd",
  "redraw an old piece": "redessiner une vieille œuvre",
  "noodles": "nouilles",
  "cook something": "cuisiner quelque chose",
  "yellow": "jaune",
  "lime": "citron vert",
  "teal": "sarcelle",
  "blue": "bleu",
  "purple": "violet foncé",
  "pink": "rose",
  "white": "blanc",
  "black": "noir",
  "sky": "ciel",
  "slate": "ardoise",
  "edit message": "modifier le message",
  "delete your message? it goes for everyone": "supprimer ton message ? il disparaît pour tout le monde",
  "delete {name}'s message? it goes for everyone": "supprimer le message de {name} ? il disparaît pour tout le monde",
  "couldn't delete that": "impossible de supprimer ça",
  "couldn't post that": "impossible de publier ça",
  "someone": "quelqu'un",
  "edited": "modifié",
  "now": "maintenant",
  "{n}m": "{n} min",
  "{n}h": "{n} h",
  "+{n} more": "+{n} autres",
  "couldn't switch": "impossible de changer",
  "switch": "changer",
  "profile": "profil",
  "that isn't a picture": "ce n'est pas une image",
  "picture saved": "image enregistrée",
  "upload picture": "téléverser une image",
  "use {name}'s discord picture": "utiliser l'image discord de {name}",
  "remove picture": "retirer l'image",
  "owned by": "appartient à",
  "remove {name} as an owner": "retirer {name} comme propriétaire",
  "owner removed": "propriétaire retiré",
  "another discord user id": "un autre identifiant discord",
  "discord user id": "id utilisateur discord",
  "add owner": "ajouter un propriétaire",
  "they can sign in as {name} now": "cette personne peut maintenant se connecter en tant que {name}",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "un compte discord propriétaire d'un alter peut se connecter et passer sur lui, indique donc ici le propre compte de l'alter",
  "she/her, they/them…": "elle, iel…",
  "a line about them": "une ligne à son sujet",
  "pronouns": "pronoms",
  "about": "à propos",
  "be {name}": "être {name}",
  "{name} is part of {system}": "{name} fait partie de {system}",
  "back to my profile": "retour à mon profil",
  "remove {name}? their notes and chats stay on the server if you add them back": "retirer {name} ? ses notes et discussions restent sur le serveur si tu la rajoutes",
  "no alters yet. add the first one above": "pas encore d'alters. ajoute le premier au-dessus",
  "{name} added": "{name} ajouté",
  "size: {size}, change": "taille : {size}, changer",
  "small": "petite",
  "half": "moitié",
  "wide": "large",
  "hide": "masquer",
  "move earlier": "avancer",
  "move later": "reculer",
  "hold to drag": "maintiens pour glisser",
  "arrange home": "organiser l'accueil",
  "ask chi": "demande à chi",
  "inbox": "boîte de réception",
  "gauges": "jauges",
  "message board": "tableau de messages",
  "spin": "lancer",
  "cat": "chat",
  "Cat mode": "Mode chat",
  "press ALT P TO EXIT CAT MODE": "appuie sur ALT P POUR QUITTER LE MODE CHAT",
  "{n} lines": "{n} traits",
  "live": "en direct",
  "no shared boards yet. make one and everyone can draw on it together": "pas encore de tableaux partagés. crées-en un et tout le monde dessine ensemble",
  "no shared boards yet. Fractal can make one": "pas encore de tableaux partagés. Fractal peut en créer un",
  "{shared} shared · {mine} yours": "{shared} partagés · {mine} à toi",
  "could not load the boards": "impossible de charger les tableaux",
  "could not make a board": "impossible de créer le tableau",
  "that board was deleted": "ce tableau a été supprimé",
  "shared board": "tableau partagé",
  "board": "tableau",
  "offline, will send when back": "hors ligne, envoi au retour",
  "that's someone else's, only they can change it": "c'est à quelqu'un d'autre, seule cette personne peut le modifier",
  "lost the board": "tableau perdu",
  "that layer is hidden, show it to draw": "ce calque est masqué, affiche-le pour dessiner",
  "that layer is hidden, show it to write": "ce calque est masqué, affiche-le pour écrire",
  "that layer is locked": "ce calque est verrouillé",
  "that layer is {who}'s, ask them to let you draw on it": "ce calque est à {who}, demande-lui l'autorisation de dessiner dessus",
  "that layer has other people's lines, use the stroke eraser": "ce calque contient des traits d'autres personnes, utilise la gomme à traits",
  "pencil found, fingers now move the board": "stylet détecté, les doigts déplacent maintenant le tableau",
  "{n} frames": "{n} images",
  "open": "ouvrir",
  "empty": "vide",
  "this layer is yours": "ce calque est à toi",
  "{who}'s layer": "calque de {who}",
  ", open to everyone": ", ouvert à tous",
  ", only they draw here": ", seule cette personne dessine ici",
  "frames": "images",
  "animate": "animer",
  "layer {n}": "calque {n}",
  "delete {name}? you can undo it": "supprimer {name} ? tu peux annuler",
  "{name} cleared, undo brings it back": "{name} vidé, annuler le ramène",
  "{n} frames is the most a layer holds": "un calque contient {n} images au maximum",
  "delete frame {n}? you can undo it": "supprimer l'image {n} ? tu peux annuler",
  "frame {n}": "image {n}",
  "frames per second": "images par seconde",
  "fps": "i/s",
  "onion skin {state}": "pelure d'oignon {state}",
  "shared · look only": "partagé · lecture seule",
  "shared · live": "partagé · en direct",
  "private": "privé",
  "paper {color}": "papier {color}",
  "could not make the picture": "impossible de créer l'image",
  "draw something first": "dessine d'abord quelque chose",
  "posted to the doodle wall": "publié sur le mur de gribouillis",
  "could not post it": "impossible de publier",
  "delete {name}? this can't be undone": "supprimer {name} ? c'est définitif",
  "delete {name}? this can't be undone, and it goes for everyone": "supprimer {name} ? c'est définitif et ça disparaît pour tout le monde",
  "could not delete it": "impossible de supprimer",
  "could not open that board": "impossible d'ouvrir ce tableau",
  "brush": "pinceau",
  "erase": "effacer",
  "select": "sélectionner",
  "shape": "forme",
  "text": "texte",
  "move": "déplacer",
  "line": "ligne",
  "arrow": "flèche",
  "box": "rectangle",
  "rub out": "gommer",
  "whole strokes": "traits entiers",
  "duplicate": "dupliquer",
  "delete": "supprimer",
  "done": "fini",
  "drag to pick, tap one stroke": "glisse pour choisir, touche un trait",
  "show": "afficher",
  "lock": "verrouiller",
  "unlock": "déverrouiller",
  "move up": "monter",
  "move down": "descendre",
  "stop playing": "arrêter la lecture",
  "play this layer": "lire ce calque",
  "previous frame": "image précédente",
  "next frame": "image suivante",
  "new empty frame": "nouvelle image vide",
  "copy this frame": "copier cette image",
  "delete this frame": "supprimer cette image",
  "move this frame earlier": "avancer cette image",
  "move this frame later": "reculer cette image",
  "plain": "uni",
  "lines": "lignes",
  "pen": "stylo",
  "pencil": "crayon",
  "ink": "encre",
  "marker": "marqueur",
  "glow": "lueur",
  "eraser": "gomme",
  "water": "eau",
  "coal": "fusain",
  "chalk": "craie",
  "crayon": "pastel",
  "rainbow": "arc-en-ciel",
  "glitter": "paillettes",
  "neon": "néon",
  "boil": "bouillonnement",
  "wave": "vague",
  "flame": "flamme",
  "march": "fourmis",
  "pulse": "pulsation",
  "draw": "dessin",
  "paint": "peinture",
  "steady": "stable",
  "pressure": "pression",
  "soft": "doux",
  "spread": "dispersion",
  "reset this brush": "réinitialiser ce pinceau",
  "multiply": "produit",
  "screen": "superposition",
  "overlay": "incrustation",
  "soft light": "lumière tamisée",
  "hard light": "lumière crue",
  "darken": "obscurcir",
  "lighten": "éclaircir",
  "color dodge": "densité couleur -",
  "color burn": "densité couleur +",
  "difference": "différence",
  "Goals": "Objectifs",
  "me": "moi",
  "Profile": "Profil",
  "Message board": "Tableau de messages",
  "Whiteboards": "Tableaux blancs",
  "nothing on the board yet": "rien sur le tableau pour l'instant",
  "add to a": "ajouter à un",
  "default": "par défaut",
  "out of": "sur",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "pas encore d'objectifs. ajoute-en un pour un chapitre à finir, un nombre de pages à atteindre ou tout ce que tu vises",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "les kana suivent le tableau gojūon standard. les kanji sont les 2 211 kanji du jlpt n5 à n1, sens et lectures de kanjidic2 (edrdg, cc by-sa 4.0), niveaux des listes jlpt de jonathan waller (cc by)",
  "bring all back": "tout remettre",
  "slices": "parts",
  "history": "historique",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "coller une liste les ajoute tous. pizza *3 rend la pizza trois fois plus probable, et les poids ci-dessous règlent ça par part",
  "no options yet. add a few, or start from a preset in options": "pas encore d'options. ajoutes-en quelques-unes, ou pars d'un préréglage dans options",
  "shuffle": "mélanger",
  "even odds": "chances égales",
  "theme colours": "couleurs du thème",
  "tally": "décompte",
  "last spins": "derniers tirages",
  "nothing spun on this wheel yet": "cette roue n'a pas encore tourné",
  "after a spin": "après un tirage",
  "keep it": "le garder",
  "knock it out": "l'éliminer",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "l'éliminer retire chaque gagnant de la roue jusqu'à ce que tu les remettes tous, pratique pour les tours de rôle et les tournois",
  "spin length": "durée du tirage",
  "quick": "rapide",
  "drama": "dramatique",
  "clicks and a jingle": "des clics et une petite mélodie",
  "new wheel from": "nouvelle roue à partir de",
  "copy this wheel": "copier cette roue",
  "delete wheel": "supprimer la roue",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "les gagnants sont tirés avec l'aléatoire sécurisé de ton appareil, en proportion du poids de chaque part, donc une part deux fois plus grande a vraiment deux fois plus de chances",
  "wheel": "roue",
  "the wheel, flick it to spin": "la roue, lance-la pour la faire tourner",
  "add options, one per line": "ajoute des options, une par ligne",
  "weight": "poids",
  "less likely": "moins probable",
  "more likely": "plus probable",
  "less": "moins",
  "more": "plus",
  "shared": "partagés",
  "new board": "nouveau tableau",
  "mine · private": "à moi · privé",
  "no boards of your own yet. only you ever see these": "pas encore de tableaux à toi. tu es le seul à les voir",
  "layers": "calques",
  "opacity": "opacité",
  "blend": "fusion",
  "let others draw on this layer": "laisser les autres dessiner sur ce calque",
  "brush ·": "pinceau ·",
  "pick from the board": "choisir sur le tableau",
  "recent": "récents",
  "any colour": "n'importe quelle couleur",
  "paper": "papier",
  "only the pencil draws, fingers move and zoom the board": "seul le stylet dessine, les doigts déplacent et zooment le tableau",
  "fit": "ajuster",
  "save png": "enregistrer en png",
  "post to doodles": "publier dans gribouillis",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "deux doigts pincent et déplacent, touche à deux doigts pour annuler, à trois pour rétablir. au clavier : espace pour faire glisser, [ et ] pour la taille, ⌘z annuler, k pinceaux, x efface des traits entiers, t texte, v sélection, u formes, virgule et point pour changer d'image, antislash pour lire",
  "delete board": "supprimer le tableau",
  "Board": "Tableau",
  "everyone on chi sees this": "tout le monde sur chi voit ça",
  "nothing on the board yet. post the first line": "rien sur le tableau pour l'instant. poste la première ligne",
  "who's here": "qui est là",
  "who is here": "qui est là",
  "jot to inbox": "noter dans la boîte",
  "say something to everyone": "dis quelque chose à tout le monde",
  "message for the board": "message pour le tableau",
  "finish the chapter 2 sprites…": "finir les sprites du chapitre 2…",
  "why, or what done looks like, optional": "pourquoi, ou à quoi ressemble « fini », facultatif",
  "progress": "progression",
  "counting what": "on compte quoi",
  "a board everyone can draw on together": "un tableau où tout le monde peut dessiner ensemble",
  "a board only you can see": "un tableau que toi seul peux voir",
  "text on the board": "texte sur le tableau",
  "back to the boards": "retour aux tableaux",
  "undo, or tap with two fingers": "annuler, ou touche à deux doigts",
  "redo": "rétablir",
  "redo, or tap with three fingers": "rétablir, ou touche à trois doigts",
  "fit the drawing on screen": "ajuster le dessin à l'écran",
  "fit to the drawing": "ajuster au dessin",
  "board settings": "réglages du tableau",
  "brush size": "taille du pinceau",
  "say something to everyone…": "dis quelque chose à tout le monde…",
  "new alter name": "nom du nouvel alter",
  "all {count} presets are taken, unpin one first": "les {count} préréglages sont pris, détache-en un d'abord",
  "could not change the owner": "impossible de changer le propriétaire",
  "groups": "groupes",
  "large": "grande",
  "layout": "disposition",
  "mine {n}": "à moi {n}",
  "owners": "propriétaires",
  "presets": "préréglages",
  "reversed": "inversé",
  "sort by": "trier par",
  "tap the star on a key to pin it. pins sit above the dock as presets": "touche l'étoile d'une touche pour l'épingler. les épingles se placent au-dessus du dock comme préréglages",
  "unknown date": "date inconnue",
  "{name} is not yours any more": "{name} n'est plus à toi",
  "{name} is yours now": "{name} est à toi maintenant",
  "Grid": "Grille",
  "Masonry": "Mosaïque",
  "Rows": "Lignes",
  "Big grid": "Grande grille",
  "Wall": "Mur",
  "Posts": "Publications",
  "Shuffle": "Mélanger",
  "random order, rolled once while it is open": "ordre aléatoire, tiré une fois tant que c'est ouvert",
  "Newest": "Plus récents",
  "latest saved first": "derniers enregistrés d'abord",
  "Oldest": "Plus anciens",
  "earliest saved first": "premiers enregistrés d'abord",
  "Most tagged": "Plus de tags",
  "refs with the most tags first": "d'abord les réfs avec le plus de tags",
  "Undescribed first": "Sans description d'abord",
  "what has no description yet comes first": "ce qui n'a pas encore de description passe en premier",
  "By tag": "Par tag",
  "grouped under the most used tag": "groupées sous le tag le plus utilisé",
  "By author": "Par auteur",
  "grouped A to Z": "groupées de A à Z",
  "By month": "Par mois",
  "grouped by the month you saved them": "groupées par mois d'enregistrement",
  "By type": "Par type",
  "stills, gifs and clips apart": "images, gifs et clips séparés",
  "sign in with discord · fractal and pauline": "connexion avec discord · fractal et pauline",
  "continue with discord": "continuer avec discord",
  "use": "utiliser",
  "Ready when you are.": "Prête quand tu veux.",
  "unit": "unité",
  "chi · online": "chi · en ligne",
  "clear": "effacer",
  "tip of the day": "astuce du jour",
  "another one": "un autre",
  "add to a budget": "ajouter à un budget",
  "every month": "chaque mois",
  "up next": "à suivre",
  "all tasks": "toutes les tâches",
  "nothing due, go draw": "rien à rendre, va dessiner",
  "routines done for today": "routines faites pour aujourd'hui",
  "no notes yet": "pas encore de notes",
  "Tasks": "Tâches",
  "chix task": "tâche chix",
  "scratchpad": "brouillon",
  "edit": "modifier",
  "view": "voir",
  "Refs": "Réfs",
  "random": "au hasard",
  "newest": "plus récents",
  "oldest": "plus anciens",
  "by tag": "par tag",
  "stills": "images",
  "moving": "animées",
  "chi's description": "description de chi",
  "your note": "ta note",
  "ctrl+enter saves and goes next": "ctrl+entrée enregistre et passe au suivant",
  "edit tags": "modifier les tags",
  "close": "fermer",
  "dialog": "boîte de dialogue",
  "info": "infos",
  "next": "suivant",
  "Chi online. What are we drawing?": "Chi en ligne. On dessine quoi ?",
  "what should I work on?": "sur quoi je travaille ?",
  "pose refs": "réfs de poses",
  "pick an oc": "choisis un oc",
  "comms": "commandes",
  "every day": "tous les jours",
  "on these days": "ces jours-là",
  "every few days": "tous les quelques jours",
  "times a week": "fois par semaine",
  "once a month": "une fois par mois",
  "mon": "lun",
  "tue": "mar",
  "wed": "mer",
  "thu": "jeu",
  "fri": "ven",
  "sat": "sam",
  "sun": "dim",
  "ping at": "rappel à",
  "paused": "en pause",
  "cancel": "annuler",
  "nothing on today": "rien aujourd'hui",
  "other days": "autres jours",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "pas encore de routines. ajoute-en une pour un croquis quotidien, un stream hebdo ou tout ce que tu veux garder",
  "Pings": "Rappels",
  "reminder": "rappel",
  "alarm": "alarme",
  "timer": "minuteur",
  "once": "une fois",
  "daily": "quotidien",
  "weekly": "hebdo",
  "set": "régler",
  "no pings yet. set one for a stream, a deadline or a break": "pas encore de rappels. règles-en un pour un stream, une échéance ou une pause",
  "focus": "concentration",
  "start": "démarrer",
  "tap the time to type your own, like 40 or 1h30": "touche l'heure pour taper la tienne, comme 40 ou 1h30",
  "0 blocks today": "0 blocs aujourd'hui",
  "keep": "garder",
  "tap a swatch to copy it, hold to toss it": "touche une pastille pour la copier, maintiens pour la jeter",
  "save prompt": "enregistrer le prompt",
  "tap a card to copy the whole prompt": "touche une carte pour copier tout le prompt",
  "Comms": "Commandes",
  "tap a commission to edit it": "touche une commande pour la modifier",
  "list": "liste",
  "money": "argent",
  "new commission": "nouvelle commande",
  "sketch": "croquis",
  "wip": "en cours",
  "review": "révision",
  "reference pics": "images de référence",
  "this month": "ce mois-ci",
  "this year": "cette année",
  "to be paid": "à encaisser",
  "paid by month": "payé par mois",
  "by client": "par client",
  "by status": "par statut",
  "a commission counts on the day it was marked paid. change that day on its card": "une commande compte le jour où elle est marquée payée. change ce jour sur sa carte",
  "left": "reste",
  "in and out": "entrées et sorties",
  "monthly by category": "mensuel par catégorie",
  "debts and goals": "dettes et objectifs",
  "one off": "ponctuel",
  "monthly": "mensuel",
  "bills": "factures",
  "costs": "dépenses",
  "debts": "dettes",
  "goals": "objectifs",
  "nothing here yet. add a bill, a debt or a goal above": "rien ici pour l'instant. ajoute une facture, une dette ou un objectif au-dessus",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "toi seul vois ça, sauf si tu l'actives pour quelqu'un dans partage. les commandes payées comptent comme entrées",
  "Gesture": "Gestuelle",
  "timed poses, draw fast, the next one drops in on its own": "poses chronométrées, dessine vite, la suivante arrive toute seule",
  "full body": "corps entier",
  "my refs": "mes réfs",
  "each pose": "chaque pose",
  "skip": "passer",
  "Japanese": "Japonais",
  "learning": "en cours",
  "show answer": "voir la réponse",
  "again": "à revoir",
  "hard": "difficile",
  "good": "bien",
  "easy": "facile",
  "space shows the answer, 1 to 4 grades it": "espace affiche la réponse, 1 à 4 pour l'évaluer",
  "decks": "paquets",
  "new cards a day": "nouvelles cartes par jour",
  "study, new cards come in this order": "étude : les nouvelles cartes arrivent dans cet ordre",
  "Characters": "Personnages",
  "chi look": "regard de chi",
  "no characters match": "aucun personnage ne correspond",
  "new character": "nouveau personnage",
  "name": "nom",
  "tags, comma separated": "tags, séparés par des virgules",
  "sheet picture": "image de fiche",
  "character file": "fichier du personnage",
  "chi saw": "chi a vu",
  "use as picture": "utiliser comme image",
  "add pic": "ajouter une image",
  "drop pic": "retirer l'image",
  "merge": "fusionner",
  "merge into": "fusionner avec",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "choisis le même personnage sous un autre nom. ses images et tout ce qui manque à cette fiche arrivent ici, et les imports mettront cette fiche à jour ensuite.",
  "Calendar": "Calendrier",
  "Maps": "Cartes",
  "near me": "près de moi",
  "maps needs a google key": "les cartes ont besoin d'une clé google",
  "in console.cloud.google.com make a project and turn on billing": "dans console.cloud.google.com crée un projet et active la facturation",
  "turn on": "active",
  "and": "et",
  "make an api key under credentials, and limit it to those three apis": "crée une clé api dans identifiants et limite-la à ces trois apis",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "colle-la dans réglages, clés, google maps. ou mets-la sur le serveur en GOOGLE_MAPS_API_KEY",
  "open setup": "ouvrir les réglages",
  "search this area": "chercher dans cette zone",
  "route here": "itinéraire jusqu'ici",
  "route from": "itinéraire depuis",
  "remove": "retirer",
  "nearby": "à proximité",
  "route": "itinéraire",
  "best rated": "mieux notés",
  "most reviews": "plus d'avis",
  "closest": "plus proches",
  "parking first": "parking d'abord",
  "add where you start and where you're going. places from nearby can go in with their route button": "ajoute d'où tu pars et où tu vas. les lieux à proximité peuvent entrer avec leur bouton itinéraire",
  "from here": "d'ici",
  "home": "maison",
  "best order for the middle stops": "meilleur ordre pour les étapes",
  "plan route": "planifier l'itinéraire",
  "time": "temps",
  "stops": "étapes",
  "pins": "épingles",
  "tap drop a pin, then tap the map where it goes": "touche poser une épingle, puis touche la carte à l'endroit voulu",
  "pin where i am": "épingler où je suis",
  "places": "lieux",
  "star a place from nearby to keep it here": "mets une étoile à un lieu à proximité pour le garder ici",
  "routes": "itinéraires",
  "plan a route and save it to keep it here": "planifie un itinéraire et enregistre-le pour le garder ici",
  "only you see these unless you switch places and routes on for someone in sharing": "toi seul vois ça, sauf si tu actives lieux et itinéraires pour quelqu'un dans partage",
  "tape": "historique",
  "scan": "scanner",
  "on this pc": "sur ce pc",
  "upload all": "tout envoyer",
  "scans the brother left in the inbox folder that the web cannot see yet": "scans que la brother a laissés dans le dossier d'entrée et que le web ne voit pas encore",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "pas encore de scans. scanne sur le pc, ou prends un croquis en photo",
  "Doodles": "Gribouillis",
  "paste": "coller",
  "no doodles yet. paste one, or add pictures from your phone": "pas encore de gribouillis. colles-en un, ou ajoute des images depuis ton téléphone",
  "doodle": "gribouillis",
  "title": "titre",
  "drawn by": "dessiné par",
  "day": "jour",
  "characters in it": "personnages dedans",
  "undo mine": "annuler le mien",
  "newer": "plus récent",
  "older": "plus ancien",
  "Server": "Serveur",
  "reload caddy": "recharger caddy",
  "memory": "mémoire",
  "load": "charge",
  "bots up": "bots actifs",
  "Logs": "Journaux",
  "nothing happened yet, it shows up here live": "rien ne s'est encore passé, ça s'affiche ici en direct",
  "billing": "facturation",
  "month": "mois",
  "key": "clé",
  "batch": "lot",
  "by model": "par modèle",
  "by person": "par personne",
  "estimates from the token counts claude sends back. billing has the real bill": "estimations d'après les tokens renvoyés par claude. la facturation a la vraie note",
  "People": "Personnes",
  "let in": "laisser entrer",
  "their chi": "son chi",
  "yours": "à toi",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "tout le monde parle à chi avec ta clé claude. ils ne la voient jamais, leurs chats et leur mémoire restent à eux, et leur part de la note est comptée ici",
  "let someone in": "laisser entrer quelqu'un",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "ils se connectent avec discord. s'ils essaient avant que tu les ajoutes, la page leur montre leur id à t'envoyer",
  "only you": "toi seul",
  "Sharing": "Partage",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "choisis ce que chaque personne peut voir. elle peut seulement le lire, jamais le changer. ça s'affiche à côté de ses notes, rappels et le reste, et son chi peut le lire aussi",
  "shared with you": "partagé avec toi",
  "nobody shares anything with you yet": "personne ne partage encore rien avec toi",
  "Setup": "Réglages",
  "anthropic api key": "clé api anthropic",
  "chat model": "modèle de chat",
  "ref tagging model": "modèle de tagging des réfs",
  "monthly tagging budget, usd": "budget mensuel de tagging, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "le tagging se met en pause quand l'estimation du mois dépasse le budget. 0 veut dire sans limite. claude-haiku-4-5 tague moins cher",
  "currency": "devise",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "rien qu'à toi. le symbole des commandes, des stats d'argent et du budget. auto le lit dans ce que tu tapes sur les commandes. ça s'enregistre dès que tu choisis",
  "log into the plane tab, then connect": "connecte-toi dans l'onglet plane, puis clique sur connecter",
  "open plane, make an api token in profile settings, paste it here": "ouvre plane, crée un jeton api dans les réglages du profil, colle-le ici",
  "connect plane": "connecter plane",
  "workspace slug": "slug de l'espace",
  "api key": "clé api",
  "load boards": "charger les tableaux",
  "chix bot": "bot chix",
  "api url": "url de l'api",
  "your discord user id": "ton id utilisateur discord",
  "browser key, optional": "clé navigateur, facultative",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "la clé api cherche les lieux et planifie les itinéraires depuis le serveur. la carte charge avec la clé navigateur s'il y en a une, sinon la clé api. GOOGLE_MAPS_API_KEY sur le serveur passe avant",
  "server": "serveur",
  "bots folder": "dossier des bots",
  "sudo password": "mot de passe sudo",
  "ssh host": "hôte ssh",
  "ssh user": "utilisateur ssh",
  "ssh key file": "fichier de clé ssh",
  "browser extension": "extension du navigateur",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "colle ça dans les options de l'extension comme jeton cloud. il est à toi, donc ce qui est enregistré l'est à ton nom",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome : décompresse par-dessus l'ancien dossier et clique sur recharger dans chrome://extensions. firefox : ouvre le fichier dans firefox et autorise-le, ensuite il se met à jour tout seul",
  "your extension token": "ton jeton d'extension",
  "copy": "copier",
  "new token": "nouveau jeton",
  "links": "liens",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "un par ligne comme nom | url. ils s'ouvrent dans l'appli bureau, ou dans un nouvel onglet sur le web",
  "desk": "bureau",
  "cloud url": "url du cloud",
  "cloud token": "jeton cloud",
  "chrome extension token": "jeton de l'extension chrome",
  "brother scan folder": "dossier de scans brother",
  "start with windows": "démarrer avec windows",
  "security": "sécurité",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "déconnecte tous les téléphones, tablettes et navigateurs connectés, y compris celui-ci. à utiliser si un appareil est perdu ou si tu penses que quelqu'un est entré",
  "log out everywhere": "se déconnecter partout",
  "pick a look": "choisis un style",
  "background pattern": "motif de fond",
  "film grain and fog": "grain de film et brouillard",
  "calm motion": "mouvement calme",
  "retry": "réessayer",
  "toss": "jeter",
  "logs": "journaux",
  "paid on": "payé le",
  "undo": "annuler",
  "setup token": "jeton de configuration",
  "talk to chi": "parler à chi",
  "jot into inbox": "noter dans la boîte",
  "whose budget": "budget de qui",
  "what kind": "quel type",
  "what it is": "ce que c'est",
  "ask chi…": "demande à chi…",
  "ask": "demander",
  "refresh": "actualiser",
  "find a task": "trouver une tâche",
  "just type, it saves itself": "tape, ça s'enregistre tout seul",
  "search notes": "chercher dans les notes",
  "back": "retour",
  "print": "imprimer",
  "# heading\n\nmarkdown works, autosave is on": "# titre\n\nle markdown marche, l'enregistrement auto est activé",
  "search refs, tags, characters": "chercher réfs, tags, personnages",
  "tile size": "taille des tuiles",
  "add pictures": "ajouter des images",
  "sort the feed": "trier le fil",
  "what you want to remember about this": "ce que tu veux retenir de ça",
  "re-index": "réindexer",
  "open post": "ouvrir le post",
  "message chi": "écrire à chi",
  "send": "envoyer",
  "a sketch a day…": "un croquis par jour…",
  "how often": "à quelle fréquence",
  "how many": "combien",
  "note, optional": "note, facultative",
  "nudge me about…": "rappelle-moi…",
  "kind": "type",
  "set the time": "régler l'heure",
  "minutes, like 40 or 1h30": "minutes, comme 40 ou 1h30",
  "reset": "réinitialiser",
  "another tip": "une autre astuce",
  "pick a colour": "choisis une couleur",
  "name, like sitting nsfw": "nom, comme assise nsfw",
  "piece": "pièce",
  "client (for the money stats)": "client (pour les stats d'argent)",
  "amount": "montant",
  "due": "échéance",
  "what they want drawn": "ce qu'on te demande de dessiner",
  "previous month": "mois précédent",
  "next month": "mois suivant",
  "what is it": "c'est quoi",
  "owed": "dû",
  "category": "catégorie",
  "only refs matching… (optional)": "seulement les réfs qui correspondent… (facultatif)",
  "add the characters from zirk.eu/oc": "ajouter les personnages de zirk.eu/oc",
  "add the characters from the discord character channel": "ajouter les personnages du salon personnages de discord",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi regarde les images des personnages et écrit des tags et une ligne sur chacun, pour mieux choisir personnages et réfs",
  "search name, race, likes, fetishes…": "chercher nom, race, goûts, fétiches…",
  "search characters…": "chercher des personnages…",
  "reload": "recharger",
  "add an event": "ajouter un événement",
  "map": "carte",
  "name it: studio, mum's, good parking": "nomme-le : atelier, chez maman, bon parking",
  "a note, optional": "une note, facultative",
  "colour": "couleur",
  "sushi, art supplies, an address": "sushi, matériel d'art, une adresse",
  "how far": "à quelle distance",
  "add a stop: address, postcode or place": "ajoute une étape : adresse, code postal ou lieu",
  "add stop": "ajouter une étape",
  "download": "télécharger",
  "add the picture on your clipboard, or press ctrl+v": "ajoute l'image du presse-papiers, ou appuie sur ctrl+v",
  "search title, artist, character, tag…": "chercher titre, artiste, personnage, tag…",
  "untitled": "sans titre",
  "type a name to add a character": "tape un nom pour ajouter un personnage",
  "count a fap": "compter un fap",
  "console.anthropic.com, api keys": "console.anthropic.com, clés api",
  "the part after the domain": "la partie après le domaine",
  "maps javascript, places (new) and routes": "maps javascript, places (new) et routes",
  "only if the map should load with its own key": "seulement si la carte doit charger avec sa propre clé",
  "find a tool or place": "trouve un outil ou un endroit",
  "what needs doing?": "qu'est-ce qu'il faut faire ?",
  "optional notes": "notes facultatives",
  "mark done": "marquer fait",
  "status": "statut",
  "link a task": "lier une tâche",
  "find a plane or chix task": "trouve une tâche plane ou chix",
  "take back the last one": "retirer le dernier",
  "take out": "retirer",
  "tasks": "tâches",
  "Today": "Aujourd'hui",
  "refs": "réfs",
  "References": "Références",
  "feed": "fil",
  "describe": "décrire",
  "Ask ChiX": "Demande à ChiX",
  "gesture": "gestuelle",
  "Gesture drawing": "Dessin gestuel",
  "Session timer": "Minuteur de session",
  "Commissions": "Commandes",
  "maps": "cartes",
  "Calculator": "Calculatrice",
  "doodles": "gribouillis",
  "Claude usage": "Utilisation de Claude",
  "people": "personnes",
  "share": "partage",
  "setup": "réglages",
  "keys": "clés",
  "themes": "thèmes",
  "studio": "atelier",
  "system": "système",
  "Home": "Accueil",
  "Studio": "Atelier",
  "Practice": "Pratique",
  "Ledger": "Comptes",
  "Library": "Bibliothèque",
  "Core": "Noyau",
  "language": "langue",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "rien qu'à toi. les textes de l'appli et les réponses de chi le suivent. ça s'enregistre dès que tu choisis",
  "Quick note": "Note rapide",
  "Reminders": "Rappels",
  "Ubuntu helpers": "Outils Ubuntu",
  "Quit": "Quitter",
  "open {name}": "ouvrir {name}",
  "sort": "tri",
  "this one is mine": "celui-ci est à moi",
  "reverse the order": "inverser l'ordre",
  "filter": "filtre",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} peut se connecter maintenant. la personne commence avec chi, notes, rappels, routines et objectifs",
  "no type": "sans type",
  "new type": "nouveau type",
  "no price": "sans prix",
  "{n} open": "{n} en cours",
  "settled": "soldé",
  "{amount} owed": "doit {amount}",
  "{amount} credit": "{amount} de crédit",
  "even": "à égalité",
  "take this back": "annuler ceci",
  "{paid} paid · {owed} still owed": "{paid} payé · reste {owed}",
  "{paid} paid, settled": "{paid} payé, soldé",
  "from credit": "depuis le crédit",
  "use {amount} credit": "utiliser {amount} de crédit",
  "pay {amount} in full": "payer {amount} en entier",
  "{n} characters": "{n} personnages",
  "{n} references": "{n} références",
  "take off": "retirer",
  "{n} saved": "{n} enregistrées",
  "default currency": "devise par défaut",
  "chi is looking...": "chi regarde...",
  "let chi describe them": "laisser chi les décrire",
  "add a character": "ajouter un personnage",
  "{amount} is over what is owed. keep it as credit for {client}?": "{amount} dépasse ce qui est dû. le garder en crédit pour {client} ?",
  "payment added": "paiement ajouté",
  "credit added": "crédit ajouté",
  "{owed} owed": "doit {owed}",
  "clients": "clients",
  "rates": "tarifs",
  "pay": "payer",
  "payment": "paiement",
  "use credit": "utiliser le crédit",
  "add credit": "ajouter du crédit",
  "owed to you": "on te doit",
  "credit held": "crédit en cours",
  "add starter set": "ajouter les types de base",
  "voice": "voix",
  "tune": "régler",
  "tune {name}": "régler {name}",
  "violet": "violet",
  "items shown": "éléments affichés",
  "cozy": "aéré",
  "auto": "auto",
  "whole home: spacing": "tout l'accueil : espacement",
  "whole home: columns (wide screens)": "tout l'accueil : colonnes (grands écrans)",
  "this browser can't listen, type here instead": "ce navigateur ne peut pas écouter, écris ici",
  "added to your inbox": "ajouté à ta boîte",
  "saved as {name}": "enregistré sous {name}",
  "sent to chi": "envoyé à chi",
  "copied": "copié",
  "open in notes": "ouvrir dans les notes",
  "no pings waiting": "aucun rappel en attente",
  "tap the mic and talk, or type": "touche le micro et parle, ou écris",
  "mic blocked": "micro bloqué",
  "could not hear": "rien entendu",
  "dictate": "dicter",
  "study": "étudier",
  "note": "note",
  "pin to home": "épingler à l'accueil",
  "pinned to home, press to unpin": "épinglée à l'accueil, appuyez pour la détacher",
  "pin {name} to home": "épingler {name} à l'accueil",
  "unpin {name} from home": "détacher {name} de l'accueil",
  "{count} pins is the limit, unpin one first": "la limite est de {count} épingles, détachez-en une d'abord",
  "Tier lists": "Tier lists",
  "new tier list": "nouvelle tier list",
  "no tier lists yet. make one, add pictures and rank them": "pas encore de tier list. créez-en une, ajoutez des images et classez-les",
  "back to my tier lists": "retour à mes tier lists",
  "tier list title": "titre de la tier list",
  "the link to this tier list": "le lien vers cette tier list",
  "stop sharing": "arrêter le partage",
  "tiers": "niveaux",
  "not ranked": "non classées",
  "pictures not ranked yet": "images pas encore classées",
  "add some pictures to start. drop them here, paste them, or pick them from your files": "ajoutez des images pour commencer. déposez-les ici, collez-les ou choisissez-les dans vos fichiers",
  "every picture is ranked": "toutes les images sont classées",
  "the picked picture": "l'image choisie",
  "name of this picture": "nom de cette image",
  "name it": "donnez-lui un nom",
  "unrank": "déclasser",
  "add tier": "ajouter un niveau",
  "put everything back": "tout remettre",
  "save picture": "enregistrer l'image",
  "delete list": "supprimer la liste",
  "tier": "niveau",
  "remove this tier": "retirer ce niveau",
  "pictures in a removed tier go back to the tray": "les images d'un niveau retiré retournent dans le plateau",
  "ranked": "classées",
  "link on": "lien actif",
  "could not load the tier lists": "impossible de charger les tier lists",
  "could not make a tier list": "impossible de créer la tier list",
  "could not open that tier list": "impossible d'ouvrir cette tier list",
  "picture": "image",
  "in tier {name}": "dans le niveau {name}",
  "in the unranked tray": "dans le plateau non classé",
  "place the picked picture in tier {name}": "placer l'image choisie dans le niveau {name}",
  "tier {name}, {count} pictures, press to change it": "niveau {name}, {count} images, appuyez pour le modifier",
  "tier {name}": "niveau {name}",
  "move tier {name} up": "monter le niveau {name}",
  "move tier {name} down": "descendre le niveau {name}",
  "tier {name} moved to row {row}": "niveau {name} déplacé à la ligne {row}",
  "now tap a tier to place it, or drag it there": "touchez maintenant un niveau pour la placer, ou glissez-la dessus",
  "drag a picture to a tier, or tap it and then tap the tier": "glissez une image vers un niveau, ou touchez-la puis touchez le niveau",
  "position {n}": "position {n}",
  "tier removed, its pictures are back in the tray": "niveau retiré, ses images sont revenues dans le plateau",
  "a tier list holds {count} pictures": "une tier list contient {count} images",
  "those are not pictures": "ce ne sont pas des images",
  "adding pictures {done} of {total}": "ajout des images {done} sur {total}",
  "{count} pictures added": "{count} images ajoutées",
  "could not add those": "impossible de les ajouter",
  "link": "lien",
  "link is on, anyone who has it can look at this list": "le lien est actif, toute personne qui l'a peut voir cette liste",
  "link is off": "le lien est désactivé",
  "could not change the link": "impossible de modifier le lien",
  "link copied": "lien copié",
  "press copy on your keyboard to copy the link": "utilisez copier au clavier pour copier le lien",
  "every picture is back in the tray": "toutes les images sont revenues dans le plateau",
  "Music": "Musique",
  "car mode": "mode voiture",
  "seek": "position",
  "previous song": "chanson précédente",
  "pause": "pause",
  "next song": "chanson suivante",
  "repeat off": "répétition désactivée",
  "repeat one song": "répéter une chanson",
  "repeat everything": "tout répéter",
  "volume": "volume",
  "vol": "vol",
  "library": "bibliothèque",
  "songs": "chansons",
  "playlists": "listes de lecture",
  "new playlist": "nouvelle liste",
  "rename playlist": "renommer la liste",
  "paste a youtube link": "collez un lien youtube",
  "get it": "la récupérer",
  "upload mp3 or m4a files": "téléverser des fichiers mp3 ou m4a",
  "youtube links are downloaded on the server into your own library. a playlist link brings every song, up to 40. files can also be dropped on this page": "les liens youtube sont téléchargés sur le serveur dans votre propre bibliothèque. un lien de liste apporte toutes les chansons, jusqu'à 40. vous pouvez aussi déposer des fichiers sur cette page",
  "downloads": "téléchargements",
  "search songs": "chercher des chansons",
  "back to playlists": "retour aux listes",
  "rename or delete this playlist": "renommer ou supprimer cette liste",
  "song": "chanson",
  "change cover": "changer la pochette",
  "remove cover": "retirer la pochette",
  "artist": "artiste",
  "album": "album",
  "downloaded from youtube": "téléchargée depuis youtube",
  "delete this song": "supprimer cette chanson",
  "delete playlist": "supprimer la liste",
  "open the music player": "ouvrir le lecteur",
  "could not load the music": "impossible de charger la musique",
  "nothing playing": "rien en lecture",
  "unknown artist": "artiste inconnu",
  "pick a song or add one": "choisissez une chanson ou ajoutez-en une",
  "details for {name}": "détails de {name}",
  "{count} songs": "{count} chansons",
  "this playlist is empty. open a song's details to add it here": "cette liste est vide. ouvrez les détails d'une chanson pour l'ajouter ici",
  "no playlists yet": "pas encore de listes",
  "nothing matches that": "rien ne correspond",
  "no songs yet. add a youtube link or upload some files": "pas encore de chansons. ajoutez un lien youtube ou téléversez des fichiers",
  "could not get it": "impossible de la récupérer",
  "downloading from youtube is not set up on this server yet. uploads work. whoever runs the server needs to install yt-dlp": "le téléchargement depuis youtube n'est pas encore configuré sur ce serveur. les téléversements fonctionnent. la personne qui gère le serveur doit installer yt-dlp",
  "that is not a youtube link": "ce n'est pas un lien youtube",
  "added to the downloads": "ajoutée aux téléchargements",
  "could not start that": "impossible de démarrer",
  "use mp3, m4a, ogg, wav or flac files": "utilisez des fichiers mp3, m4a, ogg, wav ou flac",
  "adding {done} of {total}: {name}": "ajout {done} sur {total} : {name}",
  "could not add it": "impossible de l'ajouter",
  "{count} songs added": "{count} chansons ajoutées",
  "added to {name}": "ajoutée à {name}",
  "taken out of {name}": "retirée de {name}",
  "could not change the cover": "impossible de changer la pochette",
  "delete the playlist {name}? the songs stay in your library": "supprimer la liste {name} ? les chansons restent dans votre bibliothèque",
  "all songs": "toutes les chansons",
  "shuffle everything": "tout en aléatoire",
  "could not play {name}": "impossible de lire {name}",
  "leaderboard": "classement",
  "medals": "médailles",
  "draw today": "dessine aujourd'hui",
  "suggestions": "suggestions",
  "achievements": "succès",
  "points": "points",
  "shine": "éclat",
  "rank": "rang",
  "ranks": "rangs",
  "exercise": "exercice",
  "draw a ref": "dessine une ref",
  "another": "un autre",
  "lesson": "leçon",
  "other three": "trois autres",
  "done, I drew it": "fini, j'ai dessiné",
  "drawn today, nice": "dessiné aujourd'hui, bravo",
  "no references to pick from yet": "pas encore de références à choisir",
  "how could chix be better?": "comment améliorer chix ?",
  "no suggestions yet, be the first": "pas encore de suggestions, sois le premier",
  "nobody has points yet": "personne n'a encore de points",
  "earn points to win your first medal": "gagne des points pour décrocher ta première médaille",
  "show me on the leaderboard": "m'afficher dans le classement",
  "of {n}": "sur {n}",
  "{done} of {total} achievements": "{done} succès sur {total}",
  "{n} points": "{n} points",
  "{n} need a polish": "{n} à astiquer",
  "all shining": "toutes brillent",
  "needs a polish": "à astiquer",
  "shining": "brille",
  "keep going to find out": "continue pour le découvrir",
  "{n} min": "{n} min",
  "challenge done, {n} day streak": "défi fini, série de {n} jours",
  "pick this reference": "choisir cette référence",
  "vote": "voter",
  "fewer": "moins",
  "planned": "prévue",
  "declined": "refusée",
  "achievement: {name} +{points}": "succès : {name} +{points}",
  "medal earned: {name}": "médaille gagnée : {name}",
  "Upskill": "Progresser",
  "upskill": "progresser",
  "medals gather grime every day. rub one with a finger or the mouse until it shines. a dirty medal adds less shine to your score": "les médailles s'encrassent chaque jour. frotte-en une du doigt ou à la souris jusqu'à ce qu'elle brille. une médaille sale ajoute moins d'éclat à ton score",
  "score is points plus shine, and shine is what your medals add while they are clean": "le score, c'est les points plus l'éclat, et l'éclat vient de tes médailles tant qu'elles sont propres",
  "music": "musique",
  "calendar": "calendrier",
  "session timer": "minuteur",
  "palette": "palette",
  "prompt": "idée",
  "calculator": "calculatrice",
  "scans": "scans",
  "doodle wall": "mur de gribouillis",
  "whiteboards": "tableaux blancs",
  "references": "références",
  "characters": "personnages",
  "tier lists": "tier lists",
  "gesture drawing": "dessin de gestes",
  "claude usage": "usage de claude",
  "sharing": "partage",
  "{n} songs": "{n} morceaux",
  "tap play to shuffle your library": "appuie sur lecture pour mélanger ta bibliothèque",
  "no colours saved yet": "pas encore de couleurs enregistrées",
  "no prompts saved yet": "pas encore d'idées enregistrées",
  "{owed} owed to you": "{owed} dus",
  "nobody owes you": "personne ne te doit rien",
  "no open commissions": "aucune commande ouverte",
  "calculate": "calculer",
  "make a wheel in spin first": "crée d'abord une roue dans tourner",
  "no saved places yet": "pas encore de lieux enregistrés",
  "no scans yet": "pas encore de scans",
  "the wall is empty": "le mur est vide",
  "no whiteboards yet": "pas encore de tableaux",
  "no references yet": "pas encore de références",
  "no characters yet": "pas encore de personnages",
  "{ranked} of {count} ranked": "{ranked} sur {count} classés",
  "no tier lists yet": "pas encore de tier lists",
  "5 × 30s": "5 × 30 s",
  "10 × 1m": "10 × 1 min",
  "20 × 2m": "20 × 2 min",
  "a warm up from the pose library, pick a length": "un échauffement avec la bibliothèque de poses, choisis la durée",
  "{points} points · rank {rank}": "{points} points · rang {rank}",
  "nothing logged": "rien dans les journaux",
  "of ${budget} this month": "sur ${budget} ce mois-ci",
  "up": "en marche",
  "nobody added yet": "personne d'ajouté",
  "{out} things shared by you, {incoming} people share with you": "{out} choses partagées par toi, {incoming} personnes partagent avec toi",
  "your medals": "tes médailles",
  "change the drawing": "changer le dessin",
  "add a screenshot or photo of your drawing": "ajoute une capture ou une photo de ton dessin",
  "your drawing": "ton dessin",
  "a line about it (optional)": "une ligne à son sujet (facultatif)",
  "share on the feed, +{n} points": "partager sur le fil, +{n} points",
  "add your drawing first": "ajoute d'abord ton dessin",
  "finish without sharing": "finir sans partager",
  "you drew today and shared it, nice": "tu as dessiné aujourd'hui et partagé, bravo",
  "you can still share your drawing for +{n} points": "tu peux encore partager ton dessin pour +{n} points",
  "worth +{done} points, and +{more} more when you share your drawing, plus any achievement it unlocks": "rapporte +{done} points, et +{more} de plus si tu partages ton dessin, plus les succès débloqués",
  "add your drawing": "ajouter ton dessin",
  "drew a reference": "a dessiné une référence",
  "drew {title}": "a dessiné {title}",
  "finished draw today with a reference": "a fini dessine aujourd'hui avec une référence",
  "finished draw today: {title}": "a fini dessine aujourd'hui : {title}",
  "unlocked {names}": "a débloqué {names}",
  "earned {names}": "a gagné {names}",
  "finished today's cards": "a fini les cartes du jour",
  "{n} answered": "{n} réponses",
  "open the drawing": "ouvrir le dessin",
  "the reference": "la référence",
  "cheer": "bravo",
  "drawings": "dessins",
  "studying": "études",
  "my upskilling": "mes progrès",
  "day streak": "série de jours",
  "answered today": "répondu aujourd'hui",
  "start a language in upskill and it shows up here": "commence une langue dans progresser et elle apparaîtra ici",
  "{n} posts": "{n} publications",
  "nothing on the feed yet, finish draw today or a day of cards": "rien sur le fil pour l'instant, finis dessine aujourd'hui ou une journée de cartes",
  "nothing on the feed yet": "rien sur le fil pour l'instant",
  "upskilling feed": "fil de progression",
  "Draw today": "Dessine aujourd'hui",
  "Feed": "Fil",
  "Modern Chinese": "Chinois moderne",
  "Classical Chinese": "Chinois classique",
  "modern chinese words": "mots de chinois moderne",
  "classical chinese words": "mots de chinois classique",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. drawings you share show up on the feed": "un nouvel exercice chaque jour, dans l'esprit des exercices drawabox et d'autres échauffements classiques. dessine une ref propose trois références de la bibliothèque partagée. les dessins partagés apparaissent sur le fil",
  "pick a length, draw the poses, then come back here and press done": "choisis une durée, dessine les poses, puis reviens ici appuyer sur fini",
  "session started today, {n} poses picked": "séance commencée aujourd'hui, {n} poses tirées",
  "no gesture session started today yet": "pas encore de séance de gestes aujourd'hui",
  "start a gesture session first": "commence d'abord une séance de gestes",
  "finished draw today with a gesture session": "a fini dessine aujourd'hui avec une séance de gestes",
  "drew {n} gesture poses": "a dessiné {n} poses de gestes",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. gesture starts a timed session from the pose library. drawings you share show up on the feed": "un nouvel exercice chaque jour, dans l'esprit des exercices drawabox et d'autres échauffements classiques. dessine une ref propose trois références de la bibliothèque partagée. gestes lance une séance chronométrée avec la bibliothèque de poses. les dessins partagés apparaissent sur le fil",
  "open the reference": "ouvrir la référence",
  "don't draw this one": "ne pas dessiner celle-ci",
  "draw this one": "dessiner celle-ci",
  "picked": "choisie",
  "pick": "choisir",
  "favorite": "favori",
  "favorites": "favoris",
  "to do": "à faire",
  "doing": "en cours",
  "blocked": "bloquée",
  "move to": "déplacer vers",
  "status: {status}": "statut : {status}",
  "hidden here, still open in plane": "masquée ici, toujours ouverte dans plane",
  "sure?": "sûr ?",
  "delete task": "supprimer la tâche",
  "hide task": "masquer la tâche",
  "hide the hidden": "cacher les masquées",
  "show hidden ({count})": "afficher les masquées ({count})",
  "restore": "restaurer",
  "nothing here": "rien ici",
  "trash": "corbeille",
  "tap the trash can on the card to delete it": "touche la corbeille de la carte pour la supprimer",
  "set status": "changer le statut",
  "note (optional)": "note (facultative)",
  "Linked calendars": "Calendriers liés",
  "Chi copies these in read only, one way. Changes made here never go back to them.": "Chi les copie en lecture seule, dans un seul sens. Les changements faits ici n'y retournent jamais.",
  "Name": "Nom",
  "Calendar link": "Lien du calendrier",
  "Add calendar": "Ajouter le calendrier",
  "Adding": "Ajout",
  "Proton: Settings, Calendars, Share via link (private). Google: Settings, your calendar, Secret address in iCal format. Apple: Calendar, share, Public calendar, copy link. Outlook: Settings, Shared calendars, Publish a calendar, ICS. Nextcloud: calendar menu, Copy private link.": "Proton : Paramètres, Calendriers, Partager via un lien (privé). Google : Paramètres, votre calendrier, Adresse secrète au format iCal. Apple : Calendrier, partager, Calendrier public, copier le lien. Outlook : Paramètres, Calendriers partagés, Publier un calendrier, ICS. Nextcloud : menu du calendrier, Copier le lien privé.",
  "Let Chi see this calendar": "Laisser Chi voir ce calendrier",
  "Sync now": "Synchroniser maintenant",
  "Syncing": "Synchronisation",
  "Remove": "Retirer",
  "Tap again to remove": "Touchez encore pour retirer",
  "never synced": "jamais synchronisé",
  "{count} min ago": "il y a {count} min",
  "{count} h ago": "il y a {count} h",
  "{count} d ago": "il y a {count} j",
  "synced {when} · {count} events": "synchronisé {when} · {count} événements",
  "last good sync {when}": "dernière synchro réussie {when}",
  "could not sync": "synchronisation impossible",
  "could not add that calendar": "impossible d'ajouter ce calendrier",
  "that does not look like a calendar link": "ceci ne ressemble pas à un lien de calendrier",
  "calendar links must start with https:// or webcal://": "les liens doivent commencer par https:// ou webcal://",
  "that link has a login inside it, use the private share link instead": "ce lien contient un identifiant, utilisez plutôt le lien de partage privé",
  "that address is not allowed": "cette adresse n'est pas autorisée",
  "that calendar is too big (over 5 MB)": "ce calendrier est trop gros (plus de 5 Mo)",
  "that link did not give a calendar file": "ce lien n'a pas donné de fichier de calendrier",
  "the calendar server took too long": "le serveur du calendrier a mis trop de temps",
  "could not reach that calendar": "impossible d'atteindre ce calendrier",
  "that calendar is already linked": "ce calendrier est déjà lié",
  "that is plenty of linked calendars, remove one first": "cela fait beaucoup de calendriers liés, retirez-en un d'abord",
  "too many redirects": "trop de redirections",
  "the calendar server sent a broken redirect": "le serveur du calendrier a envoyé une redirection invalide",
  "otherworld rust": "rouille de l'autre monde",
  "hospital green": "vert hôpital",
  "y2k aqua": "aqua y2k",
  "vhs blue": "bleu vhs",
  "paper zine": "fanzine papier",
  "cassette": "cassette",
  "moonlit violet": "violet lunaire",
  "lime soda": "soda citron vert",
  "rose quartz": "quartz rose",
  "sepia archive": "archive sépia",
  "deep sea lab": "labo des abysses",
  "arcade night": "nuit d'arcade",
  "velvet room": "salon de velours",
  "boudoir": "boudoir",
  "latex noir": "latex noir",
  "neon lounge": "salon néon",
  "succubus": "succube",
  "honey trap": "piège au miel",
  "cherry cola": "cola cerise",
  "after hours": "après minuit",
  "peeling paint and a rusted siren": "peinture qui s'écaille et sirène rouillée",
  "flickering corridor light, sick green tile": "lumière de couloir vacillante, carrelage vert maladif",
  "glossy bubble blue, 2001 desktop": "bleu bulle brillant, bureau de 2001",
  "tracking lines and a blue no signal screen": "lignes de tracking et écran bleu sans signal",
  "photocopied paper and red marker": "papier photocopié et feutre rouge",
  "walkman amber, warm brown tape": "ambre de walkman, bande brune chaude",
  "a quiet night in lavender light": "une nuit calme en lumière lavande",
  "fizzy lime, bright sticker shop": "citron vert pétillant, boutique de stickers",
  "pale pink stone and soft rose": "pierre rose pâle et rose doux",
  "old film stock and brown ink": "vieille pellicule et encre brune",
  "bathyscaphe lights and bioluminescent teal": "lumières de bathyscaphe et bleu canard bioluminescent",
  "cabinet glow, hot pink and electric cyan": "lueur de borne d'arcade, rose vif et cyan électrique",
  "wine velvet curtains and low red light": "rideaux de velours bordeaux et faible lumière rouge",
  "dusty rose, silk and brass lamplight": "rose poudré, soie et lampe de laiton",
  "wet black gloss and a red sliver": "noir brillant et mouillé, un filet rouge",
  "magenta tubes in a smoky bar": "tubes magenta dans un bar enfumé",
  "blood red, violet shadow, a wicked grin": "rouge sang, ombre violette, un sourire malicieux",
  "warm amber, sticky gold and candle smoke": "ambre chaud, or collant et fumée de bougie",
  "dark fizz, cherry red, diner neon": "bulles sombres, rouge cerise, néon de diner",
  "midnight indigo and rose city lights": "indigo de minuit et lumières roses de la ville",
  "otherworld": "autre monde",
  "y2k": "y2k",
  "mature": "adulte",
  "basic": "basique",
  "japanese": "japonais",
  "horror": "horreur",
  "Silkscreen titles over the pixel labels": "titres en Silkscreen sur les étiquettes pixel",
  "Pixelify Sans, a chunky bitmap face": "Pixelify Sans, une police bitmap épaisse",
  "Share Tech Mono, a thin hud readout": "Share Tech Mono, un affichage hud fin",
  "IBM Plex Mono, a tidy code face": "IBM Plex Mono, une police de code soignée",
  "Major Mono Display titles, text in Space Mono": "titres en Major Mono Display, texte en Space Mono",
  "Audiowide titles over the original labels": "titres en Audiowide sur les étiquettes d'origine",
  "Chakra Petch, angular and techy": "Chakra Petch, anguleuse et techno",
  "Unbounded titles, Lexend text": "titres en Unbounded, texte en Lexend",
  "Syne, wide and art gallery edgy": "Syne, large et style galerie d'art",
  "Monoton titles, a neon sign outline": "titres en Monoton, contour d'enseigne néon",
  "Bungee titles, shop sign letters": "titres en Bungee, lettres d'enseigne",
  "Righteous titles, a 70s poster face": "titres en Righteous, police d'affiche des années 70",
  "Bebas Neue titles, tall and flat": "titres en Bebas Neue, hauts et plats",
  "Pacifico titles, a surf shop script": "titres en Pacifico, écriture de surf shop",
  "Fraunces, a soft old style serif": "Fraunces, une serif douce de style ancien",
  "Playfair Display, high contrast and elegant": "Playfair Display, fort contraste et élégante",
  "Cormorant Garamond, a delicate book face": "Cormorant Garamond, une police de livre délicate",
  "Cinzel titles, carved roman capitals": "titres en Cinzel, capitales romaines gravées",
  "Permanent Marker titles, Gloria Hallelujah text": "titres en Permanent Marker, texte en Gloria Hallelujah",
  "Kalam, quick pen handwriting": "Kalam, écriture rapide au stylo",
  "Dancing Script titles, Kalam text": "titres en Dancing Script, texte en Kalam",
  "Indie Flower, loopy and cheerful": "Indie Flower, bouclée et joyeuse",
  "Shadows Into Light, thin felt tip": "Shadows Into Light, feutre fin",
  "Nunito, rounded and calm": "Nunito, arrondie et calme",
  "Quicksand, light and round": "Quicksand, légère et ronde",
  "Comfortaa, circles and soft curves": "Comfortaa, cercles et courbes douces",
  "Baloo 2, plump and friendly": "Baloo 2, ronde et amicale",
  "Lexend, wide open and easy to read": "Lexend, ouverte et facile à lire",
  "Josefin Sans, vintage geometric": "Josefin Sans, géométrique vintage",
  "Zen Maru Gothic, round gothic": "Zen Maru Gothic, gothique arrondie",
  "Yusei Magic, felt pen marker": "Yusei Magic, marqueur feutre",
  "Hachi Maru Pop, bubbly pop lettering": "Hachi Maru Pop, lettrage pop pétillant",
  "Reggae One titles, heavy and loud": "titres en Reggae One, lourds et criards",
  "Creepster titles, dripping horror": "titres en Creepster, horreur dégoulinante",
  "Rubik Glitch titles, a broken signal": "titres en Rubik Glitch, un signal brisé",
  "panels and screen": "panneaux et écran",
  "cursor": "curseur",
  "panel style": "style de panneau",
  "screen filter": "filtre d'écran",
  "mouse cursor": "curseur de souris",
  "cursor pack": "pack de curseurs",
  "filter strength": "force du filtre",
  "adult themes and cursors": "thèmes et curseurs pour adultes",
  "Adult themes and cursors, suggestive but never explicit. Off by default. Only affects your own screen.": "Thèmes et curseurs pour adultes, suggestifs mais jamais explicites. Désactivé par défaut. Ne change que votre propre écran.",
  "adult options on": "options adultes activées",
  "adult options off": "options adultes désactivées",
  "bracket": "crochets",
  "double line": "double trait",
  "window": "fenêtre",
  "offset": "décalé",
  "stitched": "cousu",
  "no frame": "sans cadre",
  "night vision": "vision nocturne",
  "dream": "rêve",
  "grayscale": "niveaux de gris",
  "commission": "commande",
  "delete commission": "supprimer la commande",
  "Shared with me ({count})": "Partagé avec moi ({count})",
  "sponge": "éponge",
  "cloth": "chiffon",
  "locked": "verrouillée",
  "condition": "état",
  "holo": "holo",
  "Special": "Spécial",
  "Rusty": "Rouillée",
  "Tarnished": "Ternie",
  "Dull": "Terne",
  "Clean": "Propre",
  "Mirror": "Miroir",
  "The Collection": "La collection",
  "{n} of {total}": "{n} sur {total}",
  "needs polish": "à polir",
  "fully polished": "parfaitement polie",
  "a medal you have not found yet": "une médaille pas encore trouvée",
  "Put back in the case": "Remettre dans la vitrine",
  "take the {tool}": "prendre : {tool}",
  "scrape off the rust": "gratte la rouille",
  "scrub off the grime": "frotte la crasse",
  "polish it to a shine": "polis jusqu'à l'éclat",
  "That is rust. Scrape it off with the brush first.": "C'est de la rouille. Gratte d'abord avec le pinceau.",
  "That is grime. Scrub it off with the sponge first.": "C'est de la crasse. Frotte d'abord avec l'éponge.",
  "Nothing left for the {tool}. Try the {next}.": "Plus rien pour : {tool}. Essaie : {next}.",
  "Rub the medal with the {tool}. Press space to scrub.": "Frotte la médaille avec : {tool}. Appuie sur espace pour frotter.",
  "every area of chix has its own shelf. tap a medal to take it to the workbench and clean it with the brush, the sponge and the cloth. a dirty medal adds less shine to your score": "chaque zone de chix a sa propre étagère. touche une médaille pour l'amener à l'établi et nettoie-la avec le pinceau, l'éponge et le chiffon. une médaille sale ajoute moins d'éclat à ton score",
  "{count} new medals": "{count} nouvelles médailles",
  "Earned for": "Gagnée pour",
  "How to earn it": "Comment l'obtenir",
  "Date": "Date",
  "Not earned yet": "Pas encore gagnée",
  "{n} {area} points": "{n} points {area}",
  "Close": "Fermer",
  "{n} medals": "{n} médailles",
  "{n} shining": "{n} brillantes",
  "{n} rusty": "{n} rouillées",
  "Bronze": "Bronze",
  "Silver": "Argent",
  "Gold": "Or",
  "Crystal": "Cristal",
  "Money": "Argent",
  "Menu": "Menu",
  "menu": "menu",
  "stations": "stations",
  "go to…": "aller à…",
  "places in {name}": "lieux dans {name}",
  "{count} places": "{count} lieux",
  "search every place": "chercher partout",
  "skip to content": "aller au contenu",
  "wall": "mur",
  "boards": "tableaux",
  "moodboard": "moodboard",
  "ref feed": "flux des réfs",
  "today at a glance": "la journée en un coup d'œil",
  "what to do and when": "quoi faire et quand",
  "make art, keep your world": "crée de l'art, garde ton monde",
  "get better every day": "progresse chaque jour",
  "commissions and budget": "commandes et budget",
  "small handy things": "petits outils pratiques",
  "run the app": "gérer l'app",
  "station tuner. tap for all stations, drag to tune, arrow keys to step": "accordeur de stations. touche pour tout voir, glisse pour accorder, flèches pour avancer",
  "show tasks from": "afficher les tâches de",
  "plane tasks": "tâches plane",
  "chix bot tasks": "tâches du bot chix",
  "commission tasks": "tâches de commandes",
  "on chosen weekdays": "certains jours",
  "a few times a week": "quelques fois par semaine",
  "when": "quand",
  "just once": "une seule fois",
  "every week": "chaque semaine",
  "type": "type",
  "blend mode": "mode de fusion",
  "darkening": "assombrir",
  "lightening": "éclaircir",
  "compare": "comparer",
  "what to be pinged about": "de quoi te prévenir",
  "routine name": "nom de la routine",
  "note title": "titre de la note",
  "note body": "texte de la note",
  "task name": "nom de la tâche",
  "event title": "titre de l'événement",
  "piece name": "nom de la pièce",
  "description": "description",
  "client": "client",
  "price": "prix",
  "options": "options",
  "images": "images",
  "audio files": "fichiers audio",
  "cover image": "pochette",
  "joined Chi. say hi!": "a rejoint Chi. Dis bonjour !",
  "started a shared whiteboard: {title}": "a lancé un tableau blanc partagé : {title}",
  "made a tier list public: {title}": "a rendu publique une tier list : {title}",
  "joined": "arrivée",
  "medal": "médaille",
  "art": "art",
  "open the picture": "ouvrir l'image",
  "comments": "commentaires",
  "comment": "commenter",
  "write a comment": "écris un commentaire",
  "edit post": "modifier la publication",
  "delete your post? it goes for everyone": "supprimer ta publication ? elle disparaît pour tout le monde",
  "delete {name}'s post? it goes for everyone": "supprimer la publication de {name} ? elle disparaît pour tout le monde",
  "posts": "publications",
  "events": "événements",
  "nothing on the feed yet. post the first one": "rien pour l'instant. publie le premier message",
  "post to the feed": "publier sur le fil",
  "write a post": "écris une publication",
  "post": "publier",
  "couldn't open that picture": "impossible d'ouvrir cette image",
  "a picture needs to be a png, jpeg, webp or gif": "l'image doit être un png, jpeg, webp ou gif",
  "that post is gone": "cette publication n'existe plus",
  "you can only edit your own posts": "tu ne peux modifier que tes publications",
  "that isn't yours to remove": "ce n'est pas à toi de le retirer",
  "this post has enough comments": "cette publication a assez de commentaires",
  "couldn't remove that": "impossible de retirer ça",
  "board name": "nom du tableau",
  "sure? tap again": "sûr ? touche encore",
  "{name}, plane project": "{name}, projet plane",
  "rename or delete {name}": "renommer ou supprimer {name}",
  "{count} tasks on this board. Deleting the board moves them to {inbox}.": "{count} tâches sur ce tableau. Le supprimer les renvoie dans {inbox}.",
  "board deleted, its tasks are back in {inbox}": "tableau supprimé, ses tâches sont de retour dans {inbox}"
};
